// import Fuse from "fuse.js";
// import axios from "axios";
// import API from "./api.js";

const ORDER_PAGE_STATE = window.__ORDER_PAGE_STATE__ || {}
const ORDER_PAGE_API = window.ORDER_PAGE_API || {}
const ORDER_PAGE_AUTH_HELPERS = window.ORDER_PAGE_AUTH_HELPERS || {}
const ORDER_PAGE_ROUTE_HELPERS = window.ORDER_PAGE_ROUTE_HELPERS || {}
const ORDER_PAGE_CATALOG_HELPERS = window.ORDER_PAGE_CATALOG_HELPERS || {}
const ORDER_PAGE_DATA_HELPERS = window.ORDER_PAGE_DATA_HELPERS || {}
const ORDER_PAGE_PRICING_HELPERS = window.ORDER_PAGE_PRICING_HELPERS || {}
const ORDER_PAGE_INIT_HELPERS = window.ORDER_PAGE_INIT_HELPERS || {}
const ORDER_PAGE_UI_HELPERS = window.ORDER_PAGE_UI_HELPERS || {}
const ORDER_PAGE_MISC_HELPERS = window.ORDER_PAGE_MISC_HELPERS || {}
const ORDER_PAGE_POPUP_HELPERS = window.ORDER_PAGE_POPUP_HELPERS || {}
const ORDER_PAGE_EASYBUY_HELPERS = window.ORDER_PAGE_EASYBUY_HELPERS || {}
const ORDER_PAGE_FASTBUY_HELPERS = window.ORDER_PAGE_FASTBUY_HELPERS || {}
const ORDER_PAGE_EASYBUY_ENABLED = Boolean(ORDER_PAGE_STATE.easyBuyEnabled)
const ORDER_PAGE_EASYBUY_REGISTERED = new URLSearchParams(window.location.search).get('easy_buy_registered') === '1'
const ORDER_PAGE_EASYBUY_REGISTRATION_NOTICE = new URLSearchParams(window.location.search).get('easy_buy_registration_notice') === '1'
const ORDER_PAGE_EASYBUY_START_ORDER = new URLSearchParams(window.location.search).get('easy_buy_start_order') === '1'
const ORDER_PAGE_FASTBUY_ENABLED = Boolean(ORDER_PAGE_STATE.fastBuyEnabled)
const ORDER_PAGE_EASYBUY_EMAIL_HANDLING_MODE = Number(ORDER_PAGE_STATE.easyBuyEmailHandlingMode || 1) === 2 ? 2 : 1
const ORDER_PAGE_EASY_FASTBUY_ENABLED = Boolean(ORDER_PAGE_STATE.easyFastBuyEnabled)

if (typeof window.smspvaTrackEvent !== 'function') {
    const analyticsStorageKey = 'smspva_ga4_dedupe_v2'
    const analyticsTtlMs = 30 * 24 * 60 * 60 * 1000
    const analyticsMaxEntries = 1000
    const sentInPage = {}

    const loadSentAnalyticsEvents = function() {
        try {
            const saved = JSON.parse(window.localStorage.getItem(analyticsStorageKey) || '{}')
            return saved && typeof saved === 'object' ? saved : {}
        } catch (error) {
            return {}
        }
    }

    const saveSentAnalyticsEvents = function(sent) {
        try {
            const now = Date.now()
            const entries = Object.keys(sent)
                .filter((key) => now - Number(sent[key]) < analyticsTtlMs)
                .map((key) => [key, Number(sent[key])])
                .sort((a, b) => a[1] - b[1])
                .slice(-analyticsMaxEntries)
            const compact = {}

            entries.forEach((entry) => {
                compact[entry[0]] = entry[1]
            })

            window.localStorage.setItem(analyticsStorageKey, JSON.stringify(compact))
        } catch (error) {}
    }

    window.smspvaTrackEvent = function(eventName, parameters = {}, dedupeId = '') {
        if (!eventName || typeof eventName !== 'string') {
            return false
        }

        const token = dedupeId ? eventName + ':' + String(dedupeId) : ''
        const sent = token ? loadSentAnalyticsEvents() : {}
        const now = Date.now()

        if (
            token &&
            (
                sentInPage[token] ||
                (sent[token] && now - Number(sent[token]) < analyticsTtlMs)
            )
        ) {
            return false
        }

        const payload = {
            event: eventName,
            event_schema: 'v2',
        }

        Object.keys(parameters).forEach((key) => {
            if (
                parameters[key] !== undefined &&
                parameters[key] !== null &&
                parameters[key] !== ''
            ) {
                payload[key] = parameters[key]
            }
        })

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push(payload)

        if (token) {
            sentInPage[token] = true
            sent[token] = now
            saveSentAnalyticsEvents(sent)
        }

        return true
    }
}

window.smspvaActivationParams = function(order = {}, extra = {}) {
    const dataToBuy = order.dataToBuy || {}
    const voice = Number(dataToBuy.voice || 0)
    const params = {
        order_type: 'activation',
        order_source: 'web',
        checkout_flow: 'standard',
        auth_state: window.smsUserId ? 'authenticated' : 'anonymous',
        service_code: dataToBuy.serviceId || order.opt || '',
        destination_country: dataToBuy.country || order.country || order.countrycode || '',
        operator_code: dataToBuy.operator || order.operator || '',
        number_type: voice === 2 ? 'voice' : voice === 1 ? 'caller' : 'sms',
    }

    Object.keys(extra).forEach((key) => {
        params[key] = extra[key]
    })

    return params
}

const runOrderAuthHelper = function(helperName, context, fallbackValue, args = []) {
    if (typeof ORDER_PAGE_AUTH_HELPERS[helperName] !== 'function') {
        return fallbackValue
    }

    return ORDER_PAGE_AUTH_HELPERS[helperName].apply(context, args)
}
const runOrderRouteHelper = function(helperName, context, fallbackValue, args = []) {
    if (typeof ORDER_PAGE_ROUTE_HELPERS[helperName] !== 'function') {
        return fallbackValue
    }

    return ORDER_PAGE_ROUTE_HELPERS[helperName].apply(context, args)
}
const runOrderCatalogHelper = function(helperName, context, fallbackValue, args = []) {
    if (typeof ORDER_PAGE_CATALOG_HELPERS[helperName] !== 'function') {
        return fallbackValue
    }

    return ORDER_PAGE_CATALOG_HELPERS[helperName].apply(context, args)
}
const runOrderDataHelper = function(helperName, context, fallbackValue, args = []) {
    if (typeof ORDER_PAGE_DATA_HELPERS[helperName] !== 'function') {
        return fallbackValue
    }

    return ORDER_PAGE_DATA_HELPERS[helperName].apply(context, args)
}
const runOrderPricingHelper = function(helperName, context, fallbackValue, args = []) {
    if (typeof ORDER_PAGE_PRICING_HELPERS[helperName] !== 'function') {
        return fallbackValue
    }

    return ORDER_PAGE_PRICING_HELPERS[helperName].apply(context, args)
}
const runOrderInitHelper = function(helperName, context, fallbackValue, args = []) {
    if (typeof ORDER_PAGE_INIT_HELPERS[helperName] !== 'function') {
        return fallbackValue
    }

    return ORDER_PAGE_INIT_HELPERS[helperName].apply(context, args)
}
const runOrderUiHelper = function(helperName, context, fallbackValue, args = []) {
    if (typeof ORDER_PAGE_UI_HELPERS[helperName] !== 'function') {
        return fallbackValue
    }

    return ORDER_PAGE_UI_HELPERS[helperName].apply(context, args)
}
const runOrderMiscHelper = function(helperName, context, fallbackValue, args = []) {
    if (typeof ORDER_PAGE_MISC_HELPERS[helperName] !== 'function') {
        return fallbackValue
    }

    return ORDER_PAGE_MISC_HELPERS[helperName].apply(context, args)
}
const runOrderPopupHelper = function(helperName, context, fallbackValue, args = []) {
    if (typeof ORDER_PAGE_POPUP_HELPERS[helperName] !== 'function') {
        return fallbackValue
    }

    return ORDER_PAGE_POPUP_HELPERS[helperName].apply(context, args)
}
const runOrderEasyBuyHelper = function(helperName, context, fallbackValue, args = []) {
    if (typeof ORDER_PAGE_EASYBUY_HELPERS[helperName] !== 'function') {
        return fallbackValue
    }

    return ORDER_PAGE_EASYBUY_HELPERS[helperName].apply(context, args)
}
const runOrderFastBuyHelper = function(helperName, context, fallbackValue, args = []) {
    if (typeof ORDER_PAGE_FASTBUY_HELPERS[helperName] !== 'function') {
        return fallbackValue
    }

    return ORDER_PAGE_FASTBUY_HELPERS[helperName].apply(context, args)
}
const {
    currentLang: orderPageCurrentLang = 'false',
    userBalance: orderPageUserBalance = '0',
    allServices: orderPageAllServices = [],
    allCountries: orderPageAllCountries = [],
    infoServices: orderPageInfoServices = {},
    minPrices: orderPageMinPrices = {},
    topServicesOpts: orderPageTopServicesOpts = [],
    locale: orderPageLocale = window.LANG || {},
    userName: orderPageUserName = '',
    isUserLoggedIn: orderPageIsUserLoggedIn = false,
    isOldUser: orderPageIsOldUser = false,
    serviceFromOther: orderPageServiceFromOther = false,
    karma: orderPageKarma = '',
    pageNotFound: orderPageNotFound = false,
    pageNotFoundTitle: orderPageNotFoundTitle = '',
    currentSlug: orderPageCurrentSlug = null,
    countryServiceSettings: orderPageCountryServiceSettings = [],
} = ORDER_PAGE_STATE

const app = Vue.createApp({
    data(){
        return {
            isOld: orderPageIsOldUser,
            api: ORDER_PAGE_API,
            balance: parseFloat(orderPageUserBalance),

            serviceFromOther: orderPageServiceFromOther,
            timer: null,
            additionalSettings: false,
            selectedOperator: null,
            isTypeNumberAutoAdjusting: false,
            countryServiceSettings: Array.isArray(orderPageCountryServiceSettings) ? orderPageCountryServiceSettings : [],
            // openSettings:false,
            allServices: orderPageAllServices,
            allCountries: orderPageAllCountries,
            allInfoServ: orderPageInfoServices,
            minPrices: orderPageMinPrices,
            topServicesOpts: orderPageTopServicesOpts,
            filterParamsCountry: [],
            filterTextCountry: '',
            currServOpt: 'min',
            currentCountry: '',
            filterCountryShortName: [],
            filterCountry: [],
            checkCountryF: false,
            mainLoaded: false,
            pageNotFound: orderPageNotFound,
            pageNotFoundTitle: orderPageNotFoundTitle,
            cleanupInvalidUrl: false,
            topServicesByCountry: {},
            topServicesByCountryLoaded: false,
            testbg: 4,
            pricesByCountry: {},
            pricesByCountryLoaded: false,
            pricesByService: [],
            pricesByServiceLoaded: false,
            amountByCountry: [],
            operatorRatingsByCountry: [],
            amountByCountryLoaded: false,
            amountByService: [],
            operatorRatingsByService: [],
            amountByServiceLoaded: false,
            conversationsByService: [],
            // CHANGE
            // priceModifiers: [],
            // END CHANGE
            sorting: 0,
            sortingSave: false,
            isServiceDropdownVisible: false,
            serviceSearch: '',
            isUserLoggedIn: orderPageIsUserLoggedIn,
            dots: '',
            isFirstApiDataLoaded: false,
            orders: [],
            screenWidth: window.innerWidth,
            mobile: false,
            isSortOpen: false,
            muted: false,
            rating: 0,
            ratingToView: orderPageKarma ? orderPageKarma : '',
            WD: orderPageLocale,
            popupShow: false,
            rateTemplate: 0,

            popupVariants: { 
                            notLike: "REVIEW_NOT_LIKE_TEMPLATE",
                            redirect: "REDIRECT_OLD_TEMPLATE",
                            like: "REVIEW_LIKE_TEMPLATE",
                            reviewSuccess: "REVIEW_SUCCESS",
                            skipModal: "SKIP_MODAL"
                          },
            popupTitle: {
                REVIEW_NOT_LIKE_TEMPLATE: orderPageLocale[ 'ords.popup_review_not_like_tpl'],
                REDIRECT_OLD_TEMPLATE: orderPageLocale['ords.popup.redirect_old_tpl'],
                REVIEW_LIKE_TEMPLATE: orderPageLocale['ords.popup.review_like_tpl'],
                REVIEW_SUCCESS: orderPageLocale['ords.popup.review_success'],
                SKIP_MODAL: orderPageLocale['ords.popup.skip_modal']
            },

            popup: {
                variantPopup: "",
                title: "",
                //
                labelStarBox: 'Rate new SMSpva:',
                showStarBox: true,
                starValue: 0,
                starHoverValue: 0,
                starMax: 5,
                //
                messageNoLikeSent: false,
                messageLikeSent: false,
                //
                showReview: true,
                reviewLabel: orderPageLocale['ords.popup_review_label'],
                review: '',
                showReviewError: false,
                reviewError: orderPageLocale['ords.popup_to_send_mess_fail'],

                reviewChange: function(value){
                    this.review = value
                    if(value.length > 5){
                        this.buttonsSucessDisabled = false
                        this.showReviewError = false
                    }else{
                        this.buttonsSucessDisabled = true
                        this.showReviewError = true
                    }
                },
                //
                buttonsShow: true,
                buttonsCloseDisabled: false,
                buttonsSucessDisabled: true,

            },
            // ---------------
            fuseOptions: {
                isCaseSensitive: false,
                // includeScore: false,
                // shouldSort: true,
                // includeMatches: false,
                // findAllMatches: false,
                minMatchCharLength: 1,
                // location: 0,
                threshold: 0.4,
                // distance: 100,
                // useExtendedSearch: false,
                // ignoreLocation: false,
                // ignoreFieldNorm: false,
                // fieldNormWeight: 1,
                keys: []
            },

            favoritesCountry: [],
            showFavorites: false,
            // -------------------------
            favoritesService: [],
            topServicesFiltered: [],

            showFavoritesServices: false,

            fastBuyEnabled: ORDER_PAGE_FASTBUY_ENABLED,
            isFastBuyVisible: false,
            isFastBuyParamsChanged: true,
            fastBuyRestoringOrder: false,
            fastBuyPreviewSelectionKey: '',
            fastBuyPrice: false,
            fastBuyAmount: false,
            fastBuyStep: 1,
            fastBuyStepToView: 1,
            fastBuyMessageSent: false,
            fastBuyErrorMessage: '',
            fastBuyTimer: null,
            fastBuySmsScanTimer: null,
            fastBuyPaymentScanTimer: null,
            fastBuyOrderId: null,
            fastBuyAnalyticsAttemptId: '',
            fastBuySmsWaitStartedAt: 0,
            fastBuyExpireTime: 1200,
            fastBuyTimerToView: '20:00',
            fastBuyEmail: '',
            fastBuyCC: '',
            fastBuyNumber: '',
            fastBuyFullSms: '',
            fastBuyCode: '',
            fastBuySelectedPaymentMethod: null,
            fastBuyPayments: [],
            fastBuyPayWaiting: false,
            fastBuyPayDetails: false,
            fastBuyPaymentMethodId: 112,

            newServiceModalIsVisible: false,
            newServiceName: '',
            newServiceLink: '',
            newServiceCountries: [],
            newServiceNameError: false,
            newServiceLinkError: false,

            vacancyModalIsVisible: false,
            vacancyModalName: '',
            vacancyModalPayment: '',
            vacancyModalContact: '',
            vacancyModalInfo: '',
            vacancyModalNameError: false,
            vacancyModalPaymentError: false,
            vacancyModalContactError: false,
            vacancyModalInfoError: false,

            serviceFromOtherModalIsVisible: false,

            serviceSearchSelected: false,

            NumberOfAttemptsOtherServ: 0,

            currentLang: orderPageCurrentLang,

            stopRequests: false,


            currentGetParams: '',

            showInfoTelegram: false,

            // --------- CHANGE Mode --------------

            reverseMode: false,
            countrySortedFavoritesTop: [],


            additionalTemplates: false,


            typeNumbers: "SMS",
            // typeNumbers: "SMS",
            typesNumbers: {
                SMS: {type: "SMS", name: "SMS", disabled: false, voice: 0},
                VOICE: {type: "VOICE", name: "Voice Call", disabled: false, voice: 2},
                CALLER: {type: "CALLER", name: "Caller ID", disabled: false, voice: 1},
            },



            showWelcomeModal: true, 


            showHideOperators: null,

            // CHANGE
            currentSlug: orderPageCurrentSlug ?? null,



            // EASY BUY: состояние шагов и email для гостевого сценария.
            easyBuyEnabled: ORDER_PAGE_EASYBUY_ENABLED,
            easyBuyRegistered: ORDER_PAGE_EASYBUY_REGISTERED,
            easyBuyRegistrationModal: ORDER_PAGE_EASYBUY_REGISTRATION_NOTICE,
            // The purchase form opens only after an explicit Receive SMS action.
            easyBuyRequested: false,
            easyBuyEmailHandlingMode: ORDER_PAGE_EASYBUY_EMAIL_HANDLING_MODE,
            easyFastBuyEnabled: ORDER_PAGE_EASY_FASTBUY_ENABLED,
            easyBuyStep: 0,
            easyBuyEmail: '',
            easyBuyEmailTouched: false,
            easyBuyEmailVerificationPending: false,
            easyBuyEmailCode: '',
            easyBuyCodeTouched: false,
            easyBuyVerificationLoading: false,
            easyBuyResendAvailable: false,
            easyBuyResendLoading: false,
            easyBuyResendTimer: null,
            easyBuyLoading: false,
            easyBuyPaymentSearch: '',
            easyBuyPaymentMethods: [],
            easyBuySelectedPaymentMethod: null,
            easyBuyPaymentAmount: '',
            easyBuyCaptchaToken: '',
            easyBuyCaptchaError: '',
            easyBuyCaptchaWidgetId: null,
            easyBuyCaptchaLoading: false,
            easyBuyCaptchaReady: false,
            easyBuyCaptchaRenderTimer: null,
            easyBuyStepError: '',
            easyBuyRegisteredUser: null,
            easyBuySubmitting: false,
            easyBuyInvoiceLoading: false,
            easyBuyPaymentError: '',
            easyBuyOrderError: '',
            easyBuyOrder: null,
            easyBuyPaymentStatusText: '',
            easyBuyNumberCopied: false,
            easyBuyCopyTimer: null,
            easyBuyTryAnotherLoading: false,
            easyBuySmsWaitStartedAt: 0,
            easyBuyTimer: null,
            easyBuyTimerToView: '00:00',
            easyBuyWaitingStep: 0,
            easyBuyWaitingSeconds: 60,
            easyBuyWaitingChanging: false,
            easyBuyWaitingChangeTimer: null,
            easyBuyPaymentWindowRef: null,
            easyBuyPaymentStatusTimer: null,
            easyBuyFastBuyStatusTimer: null,
            easyBuyFastBuyInvoiceStarted: false,
            easyBuyFastBuyStatusText: '',
            easyBuyFastBuyOrder: null,
            // Пополнение после лёгкой регистрации использует тот же список и invoice API,
            // что и отдельная страница платёжных систем.
            easyBuyTopupMethods: [],
            easyBuySelectedTopupMethod: null,
            easyBuyTopupAmount: '',
            easyBuyTopupLoading: false,
            easyBuyTopupInvoiceLoading: false,
            easyBuyTopupRedirecting: false,
            easyBuyTopupError: '',
            easyBuyBalancePollingTimer: null,
            easyBuyBalancePollingInFlight: false,
            easyBuyStandardOrderStarting: false,
        }   
    },
    watch: {
        
        // priceModifiers() {
        //     console.log( this.priceModifiers )
        // },

        async reverseMode() {
            localStorage.setItem('reverseMode', this.reverseMode)
            this.serviceSearch = ''
            this.filterTextCountry = ''

            if (this.reverseMode) {
                this.filterCountry = this.allCountries

                this.getTopServicesByCountry(this.currentCountry)
                this.getPricesByCountry(this.currentCountry)
                this.getAmountByCountry(this.currentCountry)
                
            } else {
                this.filterCountryF()

                // this.amountByCountryLoaded = true
                // this.pricesByCountryLoaded = true

                // this.amountByServiceLoaded = false
                // this.pricesByServiceLoaded = false

                await this.getPricesByService(this.currServOpt)
                await this.getAmountByService(this.currServOpt)

            }
            this.filterCountryTop()
            this.sorting = 0

            // CHANGE
            this.showHideOperators = null

            // EASY BUY: при смене режима возвращаем блок в стартовое состояние.
            this.resetEasyBuyState()

        },

        // EASY BUY: сохраняем email гостя локально, чтобы не терять его между обновлениями.
        easyBuyEmail() {
            if (!this.easyBuyEnabled) return
            localStorage.setItem('easyBuyEmail', this.easyBuyEmail.trim())
            this.easyBuyStepError = ''
        },
        // EASY BUY: при входе на шаг с email рендерим captcha, при выходе очищаем виджет.
        easyBuyStep(step) {
            if (!this.easyBuyEnabled) return
            if (this.easyBuyVisible && this.easyBuyStep === 2) {
                this.renderEasyBuyCaptcha()
                return
            }

            this.removeEasyBuyCaptcha(step === 2)
        },
        // EASY BUY: если блок скрывается из-за смены сервиса/страны/авторизации, убираем captcha полностью.
        easyBuyVisible() {
            if (!this.easyBuyEnabled) return
            if (this.easyBuyVisible && this.easyBuyStep === 2) {
                this.renderEasyBuyCaptcha()
                return
            }

            this.removeEasyBuyCaptcha()
        },
        easyBuyRegisteredFlow(visible) {
            if (visible) {
                this.loadEasyBuyTopupMethods()
                this.startEasyBuyBalancePolling()
                return
            }
            this.stopEasyBuyBalancePolling()
        },
        easyBuyAmountValue(amount) {
            if (!this.easyBuyRegisteredFlow || !this.easyBuySelectedTopupMethodData) return
            const minimum = Math.max(Number(amount || 0), this.easyBuyTopupMethodMinimum)
            const entered = Number(this.easyBuyTopupAmount)
            if (!Number.isFinite(entered) || entered < minimum) this.easyBuyTopupAmount = minimum.toFixed(2)
        },
        isServiceDropdownVisible(){
            this.serviceSearch = ''
        },
        showFavoritesServices(){
            this.filterServiceTop()
            localStorage.setItem('showFavServices', this.showFavoritesServices)
        },
        showFavorites(){
            if (!this.reverseMode) {
                this.filterCountryF()
            } else {
                this.filterCountryTop()
            }
        },
        async popupShow(){
            document.querySelector('html').classList.toggle('stop-scroll')
        },
        async filterParamsCountry(){
            this.filterCountryF()
        },
        async filterTextCountry(){
            this.filterCountryF()
        },

        async typeNumbers() {
            if (!this.isUserLoggedIn && this.typeNumbers !== this.typesNumbers.SMS.type) {
                this.typeNumbers = this.typesNumbers.SMS.type
                return
            }

            const keepSelectedOperator = this.isTypeNumberAutoAdjusting
            this.isTypeNumberAutoAdjusting = false

            localStorage.setItem('typeNumbers', this.typeNumbers)
            if (!keepSelectedOperator) {
                this.selectedOperator = null
            }
            this.showHideOperators = null

            if (this.mainLoaded) {
                if (this.reverseMode && this.currentCountry) {
                    this.filterCountry = this.allCountries
                    this.getTopServicesByCountry(this.currentCountry)
                    this.loadPricesByCountry(this.currentCountry)
                    this.loadAmountByCountry(this.currentCountry)
                } else if(this.currServOpt && this.currServOpt != 'min') {
                    this.filterCountryF()
                    await this.loadPricesByService(this.currServOpt)
                    await this.loadAmountByService(this.currServOpt)
                }
            }
   
        },
        /**
         * Функция currServOpt выполняет необходимые действия при изменении текущей опции сервиса.
         * Она обновляет флаги и переменные, вызывает другие функции для получения данных и
         * обновления страницы. Также она устанавливает значения для выбора оператора.
         */
        currServOpt(){
            this.clearPageNotFoundOnValidSelection()
            this.resetFastBuyPreviewState()

            const opt = this.currServOpt

            this.ensureAvailableTypeNumber()

            if (!this.reverseMode) {
                this.amountByServiceLoaded = false
                this.pricesByServiceLoaded = false
            }


            if (opt === 'min') {
                this.additionalSettings = false
            }

            if(opt && opt.length > 3){
                this.additionalSettings = true
            }

            this.getAmountByService( this.currServOpt, this.reverseMode )
            this.getPricesByService( this.currServOpt, this.reverseMode )



            this.updateURL()
            this.updatePageTitle()
            // this.selectedOperator = 'Total_' + this.currentCountry

            this.getTemplatesByServices()

            // CHANGE
            this.showHideOperators = null

            // EASY BUY: если сервис сброшен, откатываем шаги и введённый email.
            if (this.currServOpt === 'min') {
                this.resetEasyBuyState()
            }

        },

        /**
         * Функция "currentCountry" выполняет несколько операций, связанных с текущей страной.
         * Сначала она устанавливает флаги "amountByCountryLoaded" и "pricesByCountryLoaded"
         * в значение false. Затем она вызывает несколько других функций, передавая в них
         * текущую страну в качестве параметра. Эти функции загружают данные о топовых услугах,
         * ценах и количестве по стране. После этого функция обновляет URL и заголовок страницы,
         * а также устанавливает выбранного оператора в значение "Total_" + текущая страна.
         */
        async currentCountry() {
            this.clearPageNotFoundOnValidSelection()
            this.resetFastBuyPreviewState()

            this.amountByCountryLoaded = false
            this.pricesByCountryLoaded = false

            if (this.currentCountry === '') {
                this.amountByCountryLoaded = true
                this.pricesByCountryLoaded = true
                this.updateURL()
                this.updatePageTitle()
                this.getTemplatesByServices()
                this.showHideOperators = null
                this.ensureAvailableTypeNumber()
                this.resetEasyBuyState()
                return
            }
            
            if (!this.isUserLoggedIn && !this.reverseMode) {
                this.loadPricesByCountry(this.currentCountry)
                this.loadAmountByCountry(this.currentCountry)
            }
            this.ensureAvailableTypeNumber()
            this.getTopServicesByCountry(this.currentCountry)
            this.getPricesByCountry(this.currentCountry)
            this.getAmountByCountry(this.currentCountry)
            this.updateURL()
            this.updatePageTitle()
            
            // this.selectedOperator = 'Total_' + this.currentCountry

            this.getTemplatesByServices()

            // CHANGE
            this.showHideOperators = null

        },
        selectedOperator() {
            this.ensureAvailableTypeNumber()
        },

        /**
         * Функция amountByCountryLoaded проверяет, загружены ли данные о количестве по странам.
         * Если текущая страна не выбрана (значение currentCountry равно пустой строке),
         * то функция проверяет, загружены ли данные о количестве по услугам (amountByServiceLoaded).
         * Если данные о количестве по услугам загружены, то устанавливается значение mainLoaded
         * в true. Если текущая страна выбрана (значение currentCountry не пустое), то значение
         * mainLoaded также устанавливается в true.
         */
        async amountByCountryLoaded() {
            if (this.pageNotFound) {
                return
            }

            if (this.currentCountry === '') {
                if (this.amountByServiceLoaded) {this.mainLoaded = true}
            } else this.mainLoaded = true
        },

        /**
         * Функция amountByServiceLoaded асинхронно проверяет, загружены ли данные о количестве по услугам. Если
         * текущая опция услуги (currServOpt) установлена на "min", то проверяется также, загружены ли данные о
         * количестве по странам (amountByCountryLoaded). Если оба условия выполняются, то устанавливается флаг
         * mainLoaded в значение true. В противном случае, если текущая опция услуги не равна "min", то флаг
         * mainLoaded также устанавливается в значение true.
         */
        async amountByServiceLoaded() {
            if (this.pageNotFound) {
                return
            }

            if (this.currServOpt === 'min') {
                if (this.amountByCountryLoaded) {this.mainLoaded = true}
            } else this.mainLoaded = true
        },

        async orders() {
            // console.log( 'orders clear timeout')
            clearTimeout(this.timer)
        },


        async sorting() {
            localStorage.setItem('countrySort', this.sorting)
            if (!this.mobile) {
                this.isSortOpen = false
            }
        },

        async muted(){
            localStorage.setItem('isMuted', this.muted)
        },

        async isFastBuyVisible() {
            if (this.isFastBuyVisible) this.lockBodyScroll()
            else this.unlockBodyScroll()
        },

        async fastBuyEmail() {
            return runOrderFastBuyHelper('watchFastBuyEmail', this, undefined)
        },

        async fastBuyStep() {
            return runOrderFastBuyHelper('watchFastBuyStep', this, undefined)
        },
        /**
         * Функция  balance()  используется для обновления баланса пользователя на странице. Она выбирает все элементы
         * с атрибутом  id  равным "user-balance-val" и обновляет их содержимое, устанавливая значение баланса
         * пользователя с точностью до трех знаков после запятой.
         */
        async balance() {
            const elements = document.querySelectorAll("[id='user-balance-val']");
            let odd = false
            elements.forEach(element => {
                if (!odd) {
                    element.textContent = this.balance.toFixed(3);
                }
                odd = !odd
            });
        },

    },
    methods: {
        toggleFavoriteServices() {
            if (!this.showFavoritesServices && (!Array.isArray(this.favoritesService) || this.favoritesService.length === 0)) {
                this.notifyUser($L('ords.no_favorite_service'), 'error')
                return
            }

            this.showFavoritesServices = !this.showFavoritesServices
        },
        toggleFavoriteCountries() {
            if (!this.showFavorites && (!Array.isArray(this.favoritesCountry) || this.favoritesCountry.length === 0)) {
                this.notifyUser($L('ords.no_favorite_country'), 'error')
                return
            }

            this.showFavorites = !this.showFavorites
            localStorage.setItem('showCountryFavorites', this.showFavorites)
        },
        getAvailableTypeNumbers(opt = this.currServOpt, country = this.currentCountry, operator = this.selectedOperator) {
            if (!this.isUserLoggedIn) {
                return [this.typesNumbers.SMS.type]
            }

            const selectedCountry = String(country || '').trim().toUpperCase()
            const selectedService = opt && opt !== 'min' ? String(opt).trim() : ''
            const selectedOperator = String(operator || '').trim()
            const allTypes = [
                this.typesNumbers.SMS.type,
                this.typesNumbers.VOICE.type,
                this.typesNumbers.CALLER.type,
            ]

            const matchingRules = this.countryServiceSettings.filter((rule) => {
                const ruleCountry = String(rule.country || '').trim().toUpperCase()
                const ruleService = String(rule.service || '').trim()
                const ruleOperator = String(rule.operator || '').trim()

                return (!ruleCountry || ruleCountry === selectedCountry)
                    && (!ruleService || ruleService === selectedService)
                    && (!ruleOperator || ruleOperator === selectedOperator)
            })

            // No matching policy means that all three types stay available.
            if (!matchingRules.length) {
                return allTypes
            }

            /*
             * The most specific matching condition wins. Conditions with the
             * same specificity narrow the set together, so a country-only and
             * a service-only rule both apply until an explicit combination is
             * configured by an administrator.
             */
            const highestSpecificity = Math.max(...matchingRules.map((rule) => {
                return Number(!!String(rule.country || '').trim())
                    + Number(!!String(rule.service || '').trim())
                    + Number(!!String(rule.operator || '').trim())
            }))
            const effectiveRules = matchingRules.filter((rule) => {
                return Number(!!String(rule.country || '').trim())
                    + Number(!!String(rule.service || '').trim())
                    + Number(!!String(rule.operator || '').trim()) === highestSpecificity
            })

            return allTypes.filter((type) => effectiveRules.every((rule) => {
                if (type === this.typesNumbers.SMS.type) return Number(rule.sms) === 1
                if (type === this.typesNumbers.VOICE.type) return Number(rule.voice) === 1
                return Number(rule.caller) === 1
            }))
        },

        ensureAvailableTypeNumber() {
            const availableTypes = this.getAvailableTypeNumbers()

            if (!availableTypes.length) {
                return false
            }

            if (availableTypes.includes(this.typeNumbers)) {
                return true
            }

            this.isTypeNumberAutoAdjusting = true
            this.typeNumbers = availableTypes.includes(this.typesNumbers.SMS.type)
                ? this.typesNumbers.SMS.type
                : availableTypes[0]

            return true
        },

        isTypeNumberAvailable(type) {
            return this.getAvailableTypeNumbers().includes(type)
        },

        hasSelectedService() {
            return runOrderRouteHelper('hasSelectedService', this, this.currServOpt !== 'min' && !!this.getService(this.currServOpt))
        },

        hasSelectedCountry() {
            return runOrderRouteHelper('hasSelectedCountry', this, this.currentCountry !== '' && !!this.getCountryBySN(this.currentCountry))
        },

        clearPageNotFoundOnValidSelection() {
            return runOrderRouteHelper('clearPageNotFoundOnValidSelection', this, undefined)
        },

        getRouteSelections() {
            return runOrderRouteHelper('getRouteSelections', this, {
                service: this.hasSelectedService() ? this.getService(this.currServOpt) : false,
                country: this.hasSelectedCountry() ? this.getCountryBySN(this.currentCountry) : false,
            })
        },

        getLocalizedPrefixPath() {
            return runOrderRouteHelper('getLocalizedPrefixPath', this, this.currentLang && this.currentLang != 'false' && this.currentLang != 'en' ? ('/' + this.currentLang) : '')
        },

        extractUrlParamsFromLocation(fullURL = window.location.href) {
            return runOrderRouteHelper('extractUrlParamsFromLocation', this, {}, [fullURL])
        },

        // EASY BUY: единая точка перехода между шагами с проверкой email перед оплатой.
        async setEasyBuyStep(step) {
            return runOrderEasyBuyHelper('setEasyBuyStep', this, undefined, [step])
        },

        async openEasyBuy(country = '') {
            return runOrderEasyBuyHelper('openEasyBuy', this, false, [country])
        },

        async prepareEasyBuyOrder() {
            return runOrderEasyBuyHelper('prepareEasyBuyOrder', this, false)
        },

        async verifyEasyBuyEmailCode() {
            return runOrderEasyBuyHelper('verifyEasyBuyEmailCode', this, false)
        },

        async resendEasyBuyEmailCode() {
            return runOrderEasyBuyHelper('resendEasyBuyEmailCode', this, false)
        },

        async changeEasyBuyEmail() {
            return runOrderEasyBuyHelper('changeEasyBuyEmail', this, undefined)
        },

        startEasyBuyResendTimer() {
            return runOrderEasyBuyHelper('startEasyBuyResendTimer', this, undefined)
        },

        dismissEasyBuyRegistrationModal() {
            this.easyBuyRegistrationModal = false
            const url = new URL(window.location.href)
            url.searchParams.delete('easy_buy_registration_notice')
            window.history.replaceState(window.history.state, '', url.toString())
        },

        async openEasyBuyEmailStep() {
            return runOrderEasyBuyHelper('openEasyBuyEmailStep', this, undefined)
        },

        async openEasyBuyPaymentStep() {
            return runOrderEasyBuyHelper('openEasyBuyPaymentStep', this, false)
        },

        async startEasyBuyPayment() {
            return runOrderEasyBuyHelper('startEasyBuyPayment', this, false)
        },

        async copyEasyBuyNumber() {
            return runOrderEasyBuyHelper('copyEasyBuyNumber', this, false)
        },

        updateEasyBuyTimer() {
            return runOrderEasyBuyHelper('updateEasyBuyTimer', this, 0)
        },

        resetEasyBuyWaitingMessages() {
            return runOrderEasyBuyHelper('resetEasyBuyWaitingMessages', this, undefined)
        },

        updateEasyBuyWaitingMessage() {
            return runOrderEasyBuyHelper('updateEasyBuyWaitingMessage', this, undefined)
        },

        startEasyBuyTimer() {
            return runOrderEasyBuyHelper('startEasyBuyTimer', this, undefined)
        },

        stopEasyBuyTimer() {
            return runOrderEasyBuyHelper('stopEasyBuyTimer', this, undefined)
        },

        async requestAnotherEasyBuyNumber() {
            return runOrderEasyBuyHelper('requestAnotherEasyBuyNumber', this, false)
        },

        startEasyBuyOrderPolling() {
            return runOrderEasyBuyHelper('startEasyBuyOrderPolling', this, undefined)
        },

        stopEasyBuyOrderPolling() {
            return runOrderEasyBuyHelper('stopEasyBuyOrderPolling', this, undefined)
        },

        async easyBuyCheckOrder() {
            return runOrderEasyBuyHelper('easyBuyCheckOrder', this, false)
        },

        // Лёгкая регистрация: берём только карточные методы из общего Pay Systems API.
        async loadEasyBuyTopupMethods() {
            return runOrderEasyBuyHelper('loadEasyBuyTopupMethods', this, [], [])
        },

        selectEasyBuyTopupMethod(methodId) {
            return runOrderEasyBuyHelper('selectEasyBuyTopupMethod', this, undefined, [methodId])
        },

        async createEasyBuyTopupInvoice() {
            return runOrderEasyBuyHelper('createEasyBuyTopupInvoice', this, false)
        },

        startEasyBuyBalancePolling() {
            return runOrderEasyBuyHelper('startEasyBuyBalancePolling', this, undefined)
        },

        stopEasyBuyBalancePolling() {
            return runOrderEasyBuyHelper('stopEasyBuyBalancePolling', this, undefined)
        },

        async checkEasyBuyBalance() {
            return runOrderEasyBuyHelper('checkEasyBuyBalance', this, false)
        },

        async completeEasyBuyWithStandardOrder() {
            return runOrderEasyBuyHelper('completeEasyBuyWithStandardOrder', this, false)
        },

        submitEasyBuyInvoiceToWindow(html, paymentWindow) {
            return runOrderEasyBuyHelper('submitEasyBuyInvoiceToWindow', this, undefined, [html, paymentWindow])
        },

        easyBuyGetLocalPaymentMethodId() {
            return runOrderEasyBuyHelper('easyBuyGetLocalPaymentMethodId', this, '112')
        },

        // EASY BUY: держим отдельный reset, чтобы одинаково реагировать на сброс сервиса/страны/режима.
        resetEasyBuyState() {
            return runOrderEasyBuyHelper('resetEasyBuyState', this, undefined)
        },

        // EASY BUY: помечаем поле как "трогали", чтобы ошибки не показывались до взаимодействия.
        touchEasyBuyEmail() {
            return runOrderEasyBuyHelper('touchEasyBuyEmail', this, undefined)
        },

        // EASY BUY: если Turnstile-скрипт ещё не инициализировался, мягко повторяем попытку рендера.
        queueEasyBuyCaptchaRender() {
            return runOrderEasyBuyHelper('queueEasyBuyCaptchaRender', this, undefined)
        },

        loadEasyBuyCaptchaScript() {
            return runOrderEasyBuyHelper('loadEasyBuyCaptchaScript', this, null)
        },

        // EASY BUY: рендерим Turnstile в том же стиле, что и на registration/signin.
        async renderEasyBuyCaptcha() {
            return runOrderEasyBuyHelper('renderEasyBuyCaptcha', this, undefined)
        },

        // EASY BUY: полностью убираем виджет при выходе со второго шага, чтобы не копить дублей.
        removeEasyBuyCaptcha() {
            return runOrderEasyBuyHelper('removeEasyBuyCaptcha', this, undefined)
        },

        // EASY BUY: при неуспешной отправке обновляем текущий виджет Turnstile, не убирая его со второго шага.
        resetEasyBuyCaptcha() {
            return runOrderEasyBuyHelper('resetEasyBuyCaptcha', this, undefined)
        },

        async reloadEasyBuyCaptcha() {
            return runOrderEasyBuyHelper('reloadEasyBuyCaptcha', this, undefined)
        },

        // EASY BUY: инициализируем третий шаг, пока пользователь видит loader.
        async initializeEasyBuyPaymentStep() {
            return runOrderEasyBuyHelper('initializeEasyBuyPaymentStep', this, undefined)
        },

        // EASY BUY: регистрация через новый backend endpoint. Ошибки возвращаем обратно на шаг с email.
        async easyBuyRegisterUser() {
            return runOrderEasyBuyHelper('easyBuyRegisterUser', this, undefined)
        },

        // EASY BUY: получаем платёжки из нового backend endpoint, который читает тестовую таблицу fast-методов.
        async easyBuyFetchPaymentMethods() {
            return runOrderEasyBuyHelper('easyBuyFetchPaymentMethods', this, [], [])
        },

        async easyFastBuyFetchPaymentMethods() {
            return runOrderEasyBuyHelper('easyFastBuyFetchPaymentMethods', this, [], [])
        },

        // EASY BUY: выбор платёжной системы на третьем шаге.
        selectEasyBuyPaymentMethod(methodId) {
            return runOrderEasyBuyHelper('selectEasyBuyPaymentMethod', this, undefined, [methodId])
        },

        // EASY BUY: в поле суммы допускаем только целые цифры без float и посторонних символов.
        handleEasyBuyPaymentAmountInput(event) {
            return runOrderEasyBuyHelper('handleEasyBuyPaymentAmountInput', this, undefined, [event])
        },

        // EASY BUY: при выходе из поля подтягиваем сумму к допустимому минимуму, если пользователь ввёл слишком мало.
        normalizeEasyBuyPaymentAmount() {
            return runOrderEasyBuyHelper('normalizeEasyBuyPaymentAmount', this, undefined)
        },

        // EASY BUY: на третьем шаге используем тот же сценарий, что и pay_system.js, но с текущими amount/pid из easy_buy.
        async submitEasyBuyInvoice() {
            return runOrderEasyBuyHelper('submitEasyBuyInvoice', this, false)
        },

        // EASY BUY: вынес createInvoice из tpl в order.js и оставил исходный контракт ответа status/data/errormsg из paysys_api.php.
        async createEasyBuyInvoice(amount, pid) {
            return runOrderEasyBuyHelper('createEasyBuyInvoice', this, false, [amount, pid])
        },

        // EASY BUY: открываем оплату в обычной новой вкладке, а не в маленьком popup-окне.
        openEasyBuyPaymentTab() {
            return runOrderEasyBuyHelper('openEasyBuyPaymentTab', this, null)
        },

        // EASY BUY: если оплата не стартовала, закрываем заранее открытый popup и чистим ссылку.
        closeEasyBuyPaymentWindow() {
            return runOrderEasyBuyHelper('closeEasyBuyPaymentWindow', this, undefined)
        },

        // EASY BUY: фиксируем на backend, что пользователь ушёл на пополнение, и какие параметры заказа были выбраны.
        async easyBuyStorePaymentContext(started = true) {
            return runOrderEasyBuyHelper('easyBuyStorePaymentContext', this, undefined, [started])
        },

        // EASY BUY: начинаем периодически проверять баланс после ухода пользователя на страницу оплаты.
        startEasyBuyPaymentStatusPolling() {
            return runOrderEasyBuyHelper('startEasyBuyPaymentStatusPolling', this, undefined)
        },

        // EASY BUY: останавливаем polling, чтобы не плодить фоновые запросы.
        stopEasyBuyPaymentStatusPolling() {
            return runOrderEasyBuyHelper('stopEasyBuyPaymentStatusPolling', this, undefined)
        },

        // EASY BUY: если баланс пополнился и его хватает на заказ, пробуем сразу купить номер и затем перезагружаем страницу.
        async easyBuyCheckPaymentStatus() {
            return runOrderEasyBuyHelper('easyBuyCheckPaymentStatus', this, false)
        },

        // EASY BUY: отправляем в popup не исходную форму из hidden_block, а временную копию, чтобы текущая страница не уехала на оплату.
        submitEasyBuyFormToPopup(invoiceForm, paymentWindow) {
            return runOrderEasyBuyHelper('submitEasyBuyFormToPopup', this, undefined, [invoiceForm, paymentWindow])
        },

        // EASY BUY: дублируем POST на balance-endpoint с amount и invoice в query string, без тела запроса.
        async easyBuyPostBalanceRedirect(amount, pid) {
            return runOrderEasyBuyHelper('easyBuyPostBalanceRedirect', this, undefined, [amount, pid])
        },

        // EASY FASTBUY: отдельный сценарий guest-заказа через dle_fastbuy.
        async createEasyFastBuyInvoice(amount, pid) {
            return runOrderEasyBuyHelper('createEasyFastBuyInvoice', this, false, [amount, pid])
        },

        startEasyFastBuyPaymentStatusPolling() {
            return runOrderEasyBuyHelper('startEasyFastBuyPaymentStatusPolling', this, undefined)
        },

        stopEasyFastBuyPaymentStatusPolling() {
            return runOrderEasyBuyHelper('stopEasyFastBuyPaymentStatusPolling', this, undefined)
        },

        async easyFastBuyCheckOrderStatus() {
            return runOrderEasyBuyHelper('easyFastBuyCheckOrderStatus', this, false)
        },

        async fastBuy_error(data) {
            return runOrderFastBuyHelper('fastBuy_error', this, undefined, [data])
        },

        resetFastBuyPreviewState() {
            return runOrderFastBuyHelper('resetFastBuyPreviewState', this, undefined)
        },

        async initFastBuy() {
            return runOrderFastBuyHelper('initFastBuy', this, undefined)
        },

        async fastBuyStartTimer() {
            return runOrderFastBuyHelper('fastBuyStartTimer', this, undefined)
        },

        async fastBuyEndTimer() {
            return runOrderFastBuyHelper('fastBuyEndTimer', this, undefined)
        },

        async fastBuyStartSmsScan() {
            return runOrderFastBuyHelper('fastBuyStartSmsScan', this, undefined)
        },

        async fastBuyEndSmsScan() {
            return runOrderFastBuyHelper('fastBuyEndSmsScan', this, undefined)
        },

        async fastBuyStartPaymentScan() {
            return runOrderFastBuyHelper('fastBuyStartPaymentScan', this, undefined)
        },

        async fastBuyEndPaymentScan() {
            return runOrderFastBuyHelper('fastBuyEndPaymentScan', this, undefined)
        },

        normalizeFastBuySmsValue(value) {
            return runOrderFastBuyHelper('normalizeFastBuySmsValue', this, '', [value])
        },

        applyFastBuyInfoState(data) {
            return runOrderFastBuyHelper('applyFastBuyInfoState', this, false, [data])
        },

        restoreFastBuyFinalOrderFromInfo(data) {
            return runOrderFastBuyHelper('restoreFastBuyFinalOrderFromInfo', this, false, [data])
        },

        async fastBuyCancelOrder(cancelReason = '') {
            return runOrderFastBuyHelper('fastBuyCancelOrder', this, undefined, [cancelReason])
        },

        async fastBuyCloseModal() {
            return runOrderFastBuyHelper('fastBuyCloseModal', this, undefined)
        },

        async fastBuyCreateNewOrder() {
            return runOrderFastBuyHelper('fastBuyCreateNewOrder', this, undefined)
        },

        async fastBuyTryAnotherNumber() {
            return runOrderFastBuyHelper('fastBuyTryAnotherNumber', this, undefined)
        },

        canFastBuyTryAnotherNumber() {
            return runOrderFastBuyHelper('canFastBuyTryAnotherNumber', this, false)
        },

        fustBuyChangePaymentSystem() {
            return runOrderFastBuyHelper('fustBuyChangePaymentSystem', this, undefined)
        },

        async fastBuyFirstStep() {
            return runOrderFastBuyHelper('fastBuyFirstStep', this, undefined)
        },

        async fastBuySecondStep() {
            return runOrderFastBuyHelper('fastBuySecondStep', this, undefined)
        },

        async fastBuyGetInfo() {
            return runOrderFastBuyHelper('fastBuyGetInfo', this, false)
        },

        async getPaymentsMethods() {
            return runOrderFastBuyHelper('getPaymentsMethods', this, undefined)
        },

        async fastBuyPayOrder() {
            return runOrderFastBuyHelper('fastBuyPayOrder', this, undefined)
        },

        normalizeFastBuyPaymentDetails(data) {
            return runOrderFastBuyHelper('normalizeFastBuyPaymentDetails', this, data, [data])
        },

        async fastBuyPaymentAction() {
            return runOrderFastBuyHelper('fastBuyPaymentAction', this, undefined)
        },

        async saveFastBuyOrder() {
            return runOrderFastBuyHelper('saveFastBuyOrder', this, undefined)
        },

        async loadFastBuyOrder() {
            return runOrderFastBuyHelper('loadFastBuyOrder', this, false)
        },

        deleteFastBuyOrder() {
            return runOrderFastBuyHelper('deleteFastBuyOrder', this, undefined)
        },

        deleteFastBuyFinalOrder() {
            return runOrderFastBuyHelper('deleteFastBuyFinalOrder', this, undefined)
        },


        getSlugH1(currentSlug) {

            if (!currentSlug) return false

            let titleSlugKey = "ords.slug_meta_h1__" + currentSlug

            if (titleSlugKey === $L(titleSlugKey)) return false

            return $L(titleSlugKey)
                    .replaceAll("{SERVICE}", this.getService(this.currServOpt).service_name)
                    .replaceAll("{COUNTRY}", this.getCountryBySN(this.currentCountry).title_country);
        },


        changeShowHideOperators(shortname) {
            return runOrderMiscHelper('changeShowHideOperators', this, undefined, [shortname])
        },
        

        hideWelcomeModal() {
            const result = runOrderUiHelper('hideWelcomeModal', this, undefined)
            const url = new URL(window.location)
            url.searchParams.delete('msg')
            window.history.replaceState({}, '', url)
            return result
        },

        // ----------------

        showInfoAboutTypeMessage() {
            return runOrderMiscHelper('showInfoAboutTypeMessage', this, undefined)
        },

        showExternalProviderInfo() {
            return runOrderMiscHelper('showExternalProviderInfo', this, undefined)
        },

        showSmsPvaOperatorInfo() {
            return runOrderMiscHelper('showSmsPvaOperatorInfo', this, undefined)
        },

        getSmsPvaOperatorInfoText() {
            return runOrderMiscHelper('getSmsPvaOperatorInfoText', this, '')
        },

        showDonorSuccessRateInfo(successRate) {
            return runOrderMiscHelper('showDonorSuccessRateInfo', this, undefined, [successRate])
        },

        getDonorSuccessRateInfoText(successRate) {
            return runOrderMiscHelper('getDonorSuccessRateInfoText', this, '', [successRate])
        },

        isShowAnyOperator(opt, cCode) {
            return runOrderPricingHelper('isShowAnyOperator', this, false, [opt, cCode])
        },

        getHideOperators(data) {
            return runOrderPricingHelper('getHideOperators', this, false, [data])
        },
        //
        /* TEMPORARY SFR_FR / FR / WhatsApp VOICE OVERRIDE — REMOVE START */
        isWhatsappSfrVoiceOperator(operator, country, service) {
            return runOrderCatalogHelper('isWhatsappSfrVoiceOperator', this, false, [operator, country, service])
        },
        /* TEMPORARY SFR_FR / FR / WhatsApp VOICE OVERRIDE — REMOVE END */

        getPriceTotal(opt, cCode) {
            return runOrderCatalogHelper('getPriceTotal', this, false, [opt, cCode])
        },

        getCurrentVoice() {
            return runOrderCatalogHelper('getCurrentVoice', this, 0)
        },

        getPriceCacheKey(key) {
            return runOrderCatalogHelper('getPriceCacheKey', this, key, [key])
        },

        normalizePrice(price) {
            return runOrderCatalogHelper('normalizePrice', this, null, [price])
        },

        isPriceAvailable(opt, cCode, operator = false) {
            return runOrderCatalogHelper('isPriceAvailable', this, false, [opt, cCode, operator])
        },

        getDisplayPrice(opt, cCode, operator = false) {
            return runOrderCatalogHelper('getDisplayPrice', this, null, [opt, cCode, operator])
        },

        getPriceOperators(opt, cCode) {
            return runOrderCatalogHelper('getPriceOperators', this, {}, [opt, cCode])
        },

        getCheapestOperator(opt, cCode) {
            return runOrderCatalogHelper('getCheapestOperator', this, 0, [opt, cCode])
        },

        async getLastOrdersUser(opt) {
            return runOrderAuthHelper('getLastOrdersUser', this, [], [opt])
        },

        getAmountOperators(opt, cCode) {
            return runOrderCatalogHelper('getAmountOperators', this, {}, [opt, cCode])
        },

        getOperatorRating(opt, cCode, operator) {
            return runOrderCatalogHelper('getOperatorRating', this, null, [opt, cCode, operator])
        },

        getOperatorRatingClass(opt, cCode, operator) {
            return runOrderCatalogHelper('getOperatorRatingClass', this, '', [opt, cCode, operator])
        },

        getOperatorSuccessRate(opt, cCode, operator) {
            return runOrderCatalogHelper('getOperatorSuccessRate', this, null, [opt, cCode, operator])
        },

        // CHANGE
        isExternalAmountOperator(operator, cCode = false) {
            return runOrderCatalogHelper('isExternalAmountOperator', this, false, [operator, cCode])
        },

        getExternalOperatorsAmount(opt, cCode) {
            return runOrderCatalogHelper('getExternalOperatorsAmount', this, {}, [opt, cCode])
        },

        getExternalOperatorName(operator, cCode = false) {
            return runOrderCatalogHelper('getExternalOperatorName', this, operator, [operator, cCode])
        },

        getOperatorPublicName(operator, cCode = false) {
            return runOrderCatalogHelper('getOperatorPublicName', this, operator, [operator, cCode])
        },
        // END CHANGE

        additTextFromPrice(opt, cCode) {
            return runOrderCatalogHelper('additTextFromPrice', this, false, [opt, cCode])
        },

        getAvailableCountOperators(opt, cCode, operator = false, donor = false) {
            return runOrderCatalogHelper('getAvailableCountOperators', this, 0, [opt, cCode, operator, donor])
        },

        getNumberHandlerInterlayer(cCode, service, operator) {
            return runOrderPricingHelper('getNumberHandlerInterlayer', this, undefined, [cCode, service, operator])
        },

        operatorNameWithoutSuffix(operator) {
            return runOrderPricingHelper('operatorNameWithoutSuffix', this, operator, [operator])
        },

        // getAmountForOperators(operator, count, cCode, opt) {

        //     if (this.operatorNameWithoutSuffix(operator) != 'Total') {
        //         return count
        //     }

        //     if (!cCode || !opt) return count

        //     let amountWithoutTotal =  this.getAvailableCountOperators(opt, cCode, "Total_" + cCode)

        //     if (!amountWithoutTotal) return count

        //     let total = count - amountWithoutTotal


        //     return total <= 0 ? 0 : total
        // },

        getPriceByCountry(country, opt, operator) {
            return runOrderCatalogHelper('getPriceByCountry', this, 0, [country, opt, operator])
        },

        getServicePrice(opt, cCode, operator) {
            return runOrderCatalogHelper('getServicePrice', this, 0, [opt, cCode, operator])
        },
        //

        getTemplatesByServices () {
            return runOrderDataHelper('getTemplatesByServices', this, false)
        },

        checkDropDownElements() {
            return runOrderDataHelper('checkDropDownElements', this, false)
        },
        // getPriceModifiers (country, service) {
        //     if (!country || !service) {
        //         return false
        //     }
        //     if (!this.priceModifiers || !this.priceModifiers.hasOwnProperty(country)) {
        //         return false
        //     }
        //     if (!this.priceModifiers[country].hasOwnProperty(service) || !this.priceModifiers[country][service].hasOwnProperty('modifier')) {
        //         return false
        //     }
            
        //     let newPrice = 0

        //     if (this.pricesByService.hasOwnProperty(service) && this.pricesByService[service].hasOwnProperty(country)) {

        //         newPrice = this.pricesByService[service][country] * this.priceModifiers[country][service].modifier

        //     } else if (this.pricesByCountry.hasOwnProperty(country) || !this.pricesByCountry[country].hasOwnProperty(service)) {

        //         newPrice = this.pricesByCountry[country][service]  * this.priceModifiers[country][service].modifier
        //     }
            
        //     return isNaN(newPrice) ? 0 : newPrice.toFixed(2);
        // },

        filterCountryTop(){
            return runOrderPricingHelper('filterCountryTop', this, undefined)
        },




        getPriceOperator (country, opt, operator) {
            return runOrderPricingHelper('getPriceOperator', this, 0, [country, opt, operator])
        },

        // getAmountByServive (cShortName) {
        //     if (cShortName == this.currentCountry) {

        //         return this.getAmountOperator( this.currServOpt, cShortName )

        //     } else if (this.amountByService[this.currServOpt] && this.amountByService[this.currServOpt][cShortName]) {

        //         // let cheapOperator = this.getCheapestOperator(this.currServOpt, cShortName)

        //         // if (cShortName == "US") {
        //         //     console.log(cheapOperator)
        //         // }

        //         // if (cheapOperator && cheapOperator.amount) {
        //         //     return cheapOperator.amount
        //         // } else {
        //             return this.amountByService[this.currServOpt][cShortName]['Other_' + cShortName]
        //         // }
        //     }

        //     return 0
        // },

        // getAmountOperator( service , countryShortname){

        //     if ( !service || !countryShortname ) {

        //         if ( service && this.amountByService[service][countryShortname]['Other_' + countryShortname] ){
        //             return this.amountByService[service][countryShortname]['Other_' + countryShortname]
        //         } else {
        //             return 0
        //         }

        //     }

        //     if ( this.selectedOperator && this.currServOpt != 'min' && this.currentCountry && this.currentCountry.length > 0 ) {

        //         if ( 
        //             this.currentCountry == countryShortname &&
        //             this.amountByService[ this.currServOpt ] && 
        //             this.amountByService[ this.currServOpt ][  this.currentCountry ]
        //         ) {

        //             return this.amountByService[ this.currServOpt ][  this.currentCountry ][ this.selectedOperator ]
        //         }

        //     }

        //     if ( 
        //         this.amountByService[service] && this.amountByService[service][countryShortname] &&
        //         this.amountByService[service][countryShortname]['Total_' + countryShortname] 
        //     ) {

        //         return this.amountByService[service][countryShortname]['Total_' + countryShortname]
        //     }

        //     return 0
           
        // },
        //  end changed 

        replaceText( text, replaseObj ){   
            return runOrderMiscHelper('replaceText', this, false, [text, replaseObj])
        },

        // async getPrices(){

        //     let data = new FormData()
        //     data.append('method', 'GET_MIN_PRICES')

        //     axios({
        //         method: 'post',
        //         url: '/sms_api/orders.php',
        //         data: data
        //     }).then( async function( response ) {

        //         if( response.data.res && response.data.data ){

        //             this.pricesByCountry = response.data.data
        //         }

        //     }.bind(this)).catch(function (err) {
        //         console.log(err)
        //     });


        // },

        async getServiceByOpt( ){
            return runOrderAuthHelper('getServiceByOpt', this, false)
        },

        checkServiceFromOther: function( check ){
            return runOrderAuthHelper('checkServiceFromOther', this, false, [check])
        },

        // EDIT

        async ChooseAnotherServiceInsteadOfOther(){
            return runOrderAuthHelper('ChooseAnotherServiceInsteadOfOther', this, false)
        },

        async changeServiceFromOther(){
            return runOrderAuthHelper('changeServiceFromOther', this, false)
        },


        async deleteServiceFromOther( service ){
            return runOrderAuthHelper('deleteServiceFromOther', this, false, [service])
        },


        closeFromOtherModal(){
            this.deleteServiceFromOther( this.serviceFromOther )
            this.serviceFromOther = false;
            this.getNumberHandler( this.currentCountry );
            this.serviceFromOtherModalIsVisible = !this.serviceFromOtherModalIsVisible;
            // this.watchServiceFromOther()
        },

        //

        /**
         * Эта функция используется для отправки метрик в сторонний аналитический инструмент.
         */
        async sendMetrics(event){
            // if (typeof window.gtag != 'undefined') {
            //     // window.ym(35933445, 'reachGoal', event);
            //     gtag('event', event);
            // }else {
            //     console.log('Metrics not initialized');
            // }
        },

        async goTo(link) {
            return runOrderMiscHelper('goTo', this, undefined, [link])
        },

        /**
         * Асинхронная функция  `copyText`  создает временное текстовое поле
         * ( `textarea` ), копирует в него переданный текст, добавляет поле
         * на страницу, выделяет текст в поле, выполняет команду копирования ( `copy` ),
         * удаляет поле со страницы и выводит уведомление пользователю о успешном копировании.
         */
        async copyText(text) {
            return runOrderUiHelper('copyText', this, undefined, [text])
        },

        /**
         * Функция  scrollToTryItOut  используется для прокрутки страницы к элементу с идентификатором "info_box".
         * Она вызывается только если пользователь находится на мобильном устройстве и не авторизован. Прокрутка
         * осуществляется плавно, начиная с верхней части страницы.
         */
        async scrollToTryItOut(){
            return runOrderUiHelper('scrollToTryItOut', this, undefined)
        },

        /**
         * Функция  `lockBodyScroll`  используется для блокировки прокрутки страницы.
         * Она находит элемент  `body`  документа и изменяет его стили, чтобы предотвратить
         * прокрутку. Конкретно, устанавливаются следующие стили:  `overflow: hidden` ,
         * `position: fixed` ,  `width: 100%` . Это позволяет создать эффект фиксированного
         * экрана без возможности прокрутки содержимого.
         */
        async lockBodyScroll(){
            return runOrderUiHelper('lockBodyScroll', this, undefined)
        },

        /**
         * Эта функция разблокирует прокрутку документа, устанавливая значения стилей
         * overflow и position элемента body в null.
         */
        async unlockBodyScroll() {
            return runOrderUiHelper('unlockBodyScroll', this, undefined)
        },

        /**
         * Функция  `playNotification`  используется для воспроизведения звукового уведомления.
         * Она принимает один параметр  `ignoreMute` , который по умолчанию равен  `false` .
         * Если звук уведомлений отключен ( `muted = true` ) и  `ignoreMute`  не равно  `true` ,
         * то функция ничего не делает. В противном случае, она проигрывает звуковой файл,
         * доступный по идентификатору 'sms-audio'.
         */
        playNotification(ignoreMute = false){
            return runOrderUiHelper('playNotification', this, undefined, [ignoreMute])
        },

        /**
         * Функция  validateEmail(email)  используется для проверки правильности формата электронной почты.
         * Она принимает входной параметр  email  и возвращает логическое значение  true  или  false ,
         * в зависимости от того, соответствует ли переданный адрес электронной почты заданному формату.
         */
        validateEmail(email) {
            return runOrderMiscHelper('validateEmail', this, false, [email])
        },

        /**
         * Код выполняет операцию выбора/отмены выбора страны в новом сервисе. Если страна уже выбрана, она добавляется
         * в массив newServiceCountries. Если страна уже присутствует в массиве, она удаляется из него.
         */
        async selectCountryInNewService(shortname) {
            return runOrderMiscHelper('selectCountryInNewService', this, undefined, [shortname])
        },

        /**
         * Данная функция  selectAllInAddNewService()  выполняет следующие действия:
         * - Проверяет, если количество стран в массиве  allCountries  равно количеству стран в массиве  newServiceCountries .
         * - Если количество стран в обоих массивах совпадает, то очищает массив  newServiceCountries .
         * - Если количество стран в массивах не совпадает, то очищает массив  newServiceCountries  и затем добавляет в
         * него сокращенные названия всех стран из массива  allCountries .
         */
        async selectAllInAddNewService() {
            return runOrderMiscHelper('selectAllInAddNewService', this, undefined)
        },

        /**
         * Асинхронная функция sendRequestToAddNewService() отправляет запрос на добавление нового сервиса. В начале
         * функции происходит проверка наличия ошибок ввода имени и ссылки на сервис. Если поле имени или ссылки пустое,
         * устанавливается соответствующий флаг ошибки. Затем проверяется, выбраны ли страны для этого сервиса, и в
         * случае их отсутствия выводится предупреждение. Если все проверки пройдены успешно, формируется сообщение с
         * информацией о новом сервисе, выбранных странах и отправляется в поддержку через MeTalk. Затем модальное окно
         * для добавления нового сервиса скрывается.
         */
        async sendRequestToAddNewService() {
            return runOrderMiscHelper('sendRequestToAddNewService', this, undefined)
        },
        async sendRequestToVacancy() {
            return runOrderMiscHelper('sendRequestToVacancy', this, undefined)
        },

        /**
         * Эта функция используется для переключения отображения избранных стран.
         * Сначала она устанавливает значение 'showCountryFavorites' в
         * localStorage в противоположное текущему значению переменной
         * 'showFavorites'. Затем она обновляет значение переменной
         * 'showFavorites' на противоположное значение. Это позволяет
         * пользователю показывать или скрывать избранные страны на экране.
         */
        showFavoritesF(){
            return runOrderUiHelper('showFavoritesF', this, undefined)
        },

        /**
         * Функция filterServiceTop() используется для фильтрации списка верхних сервисов.
         *
         * Сначала происходит проверка каждого сервиса из списка topServicesFiltered. Если
         * этот сервис не содержится в списке favoritesService и не содержится в списке
         * topServicesOpts, то он удаляется из списка topServicesFiltered.
         *
         * Затем происходит проверка каждого сервиса из списка favoritesService. Если
         * этот сервис не содержится в списке topServicesFiltered, то он добавляется в
         * начало списка topServicesFiltered. Если же этот сервис уже содержится в
         * списке topServicesFiltered и также содержится в списке topServicesOpts,
         * то он перемещается в начало списка topServicesFiltered.
         *
         * Основная цель функции - упорядочить список верхних сервисов таким образом,
         * чтобы сервисы из списка favoritesService были первыми, а затем следовали
         * остальные сервисы из списка topServicesFiltered.
         */
        filterServiceTop(){
            return runOrderUiHelper('filterServiceTop', this, undefined)
        },

        /**
         * Функция  checkFavoritesCountry  проверяет, есть ли в списке избранных стран переданный краткий код страны.
         * Если передан пустой краткий код или список избранных стран пуст или содержит менее одной страны, функция
         * возвращает  false . В противном случае, функция проверяет, включает ли список избранных стран переданный
         * краткий код и возвращает соответствующее значение.
         */
        checkFavoritesCountry(shortname){
            return runOrderUiHelper('checkFavoritesCountry', this, false, [shortname])
        },

        /**
         * Функция  checkFavoritesService  проверяет, есть ли в списке избранных услуг переданная опция. Если передана
         * пустая опция или список избранных услуг пуст или содержит менее одной услуги, функция возвращает  false . В
         * противном случае, функция проверяет, включает ли список избранных услуг переданную опцию и возвращает
         * соответствующее значение.
         */
        checkFavoritesService(opt){
            return runOrderUiHelper('checkFavoritesService', this, false, [opt])
        },

        /**
         * Функция  clickFavoritesService  добавляет или удаляет переданную опцию из списка избранных услуг. Если
         * передана пустая опция, функция возвращает  false . Если список избранных услуг равен  null , он
         * инициализируется пустым массивом. Если переданная опция не включена в список избранных услуг, она
         * добавляется в него. В противном случае, опция удаляется из списка. Если опция также включена в список
         * верхних услуг и в отфильтрованном списке верхних услуг, она перемещается в конец списка. Затем список
         * избранных услуг сохраняется в локальном хранилище, и вызывается функция  filterServiceTop .
         */
        clickFavoritesService(opt){
            return runOrderUiHelper('clickFavoritesService', this, false, [opt])
        },

        /**
         * Функция  clickFavoritesCountry  добавляет или удаляет переданный краткий код страны из списка избранных
         * стран. Если передан пустой краткий код, функция возвращает  false . Если список избранных стран равен  null
         * , он инициализируется пустым массивом. Если переданный краткий код не включен в список избранных стран, он
         * добавляется в него. В противном случае, краткий код удаляется из списка. Затем список избранных стран
         * сохраняется в локальном хранилище.
         */
        clickFavoritesCountry(shortname){
            return runOrderUiHelper('clickFavoritesCountry', this, false, [shortname])
        },

        /**
         * Функция  clickRateStar  отвечает за обработку действия пользователя по клику на звезду для оценки. Если
         * сообщение уже было отправлено пользователю, то функция изменяет заголовок всплывающего окна на "Отзыв
         * успешно отправлен", устанавливает соответствующий вариант всплывающего окна, скрывает блок для написания
         * отзыва и блок выбора звезд, а также активирует кнопки для успешного завершения. Затем функция отображает
         * всплывающее окно.
         *
         * Если сообщение еще не было отправлено, то функция показывает блок для написания отзыва и блок выбора звезд,
         * устанавливает заголовок всплывающего окна на "Нравится", устанавливает соответствующий вариант всплывающего
         * окна и отображает всплывающее окно.
         */
        clickRateStar(){
            return runOrderPopupHelper('clickRateStar', this, undefined)
        },

        /**
         * Функция sendPopup() отвечает за обработку различных вариантов всплывающего окна.
         *
         * Сначала происходит проверка текущего варианта окна. Если это вариант notLike и длина отзыва меньше или равна
         * 5, то устанавливается флаг showReviewError в true и возвращается значение false.
         *
         * Если вариант notLike и длина отзыва больше 5, то флаги showReview, showStarBox и messageNoLikeSent
         * устанавливаются в false, а заголовок окна и вариант окна изменяются на значения из объекта popupTitle и
         * popupVariants соответственно. Затем вызывается функция sendFeedback() для отправки отзыва, а также
         * устанавливается флаг messageNoLikeSent в true и очищается поле отзыва.
         *
         * Если вариант окна redirect, то флаг popupShow устанавливается в false, а заголовок и вариант окна изменяются
         * на значения для варианта notLike. Затем происходит отправка GET-запроса на сервер с изменением скина и
         * перенаправление пользователя на главную страницу.
         *
         * Если вариант окна like, то вызывается функция sendFeedback() для отправки отзыва, а затем флаг popupShow
         * устанавливается в false, а заголовок и вариант окна изменяются на значения для варианта notLike. После
         * задержки в 500 миллисекунд, поле отзыва очищается.
         *
         * Если вариант окна reviewSuccess, то флаг popupShow устанавливается в false.
         *
         * В случае, если вариант окна не соответствует ни одному из указанных вариантов, то флаг popupShow
         * устанавливается в false, а заголовок и вариант окна изменяются на значения для варианта notLike, а также
         * устанавливается флаг buttonsSucessDisabled в true.
         */
        sendPopup(){
            return runOrderPopupHelper('sendPopup', this, undefined)
        },

        /**
         * Функция "skipModalReview" используется для пропуска модального окна с обзором. Внутри функции происходит
         * изменение свойств объекта "popup". Заголовок модального окна меняется на значение из массива "popupTitle" с
         * индексом, соответствующим варианту "skipModal". Также меняется вариант модального окна на "redirect",
         * отключается блокировка кнопок "success" и отключаются отображения блока с оценкой и блока с обзором.
         */
        skipModalReview(){
            return runOrderPopupHelper('skipModalReview', this, undefined)
        },

        /**
         * Функция "returnBackTemplate" используется для возврата к предыдущему шаблону. Если было отправлено сообщение
         * об отсутствии понравившегося элемента, то отключаются отображения блока с обзором и блока с оценкой,
         * меняется заголовок модального окна на значение из массива "popupTitle" с вариантом "redirect", меняется
         * вариант модального окна на "redirect" и отображается модальное окно. В противном случае блокируются кнопки
         * "success", отображаются блоки с обзором и оценкой, меняется заголовок модального окна на значение из массива
         * "popupTitle" с вариантом "notLike", меняется вариант модального окна на "notLike" и отображается модальное
         * окно.
         */
        returnBackTemplate(){
            return runOrderPopupHelper('returnBackTemplate', this, undefined)
        },


        /**
         * Функция  sendFeedback  асинхронно отправляет отзыв о тексте  text . Опционально можно указать оценку  rate
         * (по умолчанию -  false ) и флаг  isBack  (по умолчанию -  false ).
         *
         * Внутри функции создается объект  FormData  и добавляются необходимые параметры: метод  LEAVE_FEEDBACK  и сам
         * текст отзыва. Если указана оценка, то она также добавляется. Если флаг  isBack  равен  true , то добавляется
         * параметр  isBack  со значением  1 , иначе  0 .
         *
         * Затем используется библиотека  axios  для отправки POST-запроса на URL  /sms_api/orders.php  с переданными
         * данными. В случае успешного выполнения запроса, выполняется пустая функция. В случае ошибки, выводится
         * сообщение об ошибке в консоль.
         */
        async sendFeedback(text, rate = false, isBack = false){
            return runOrderPopupHelper('sendFeedback', this, undefined, [text, rate, isBack])
        },


        /**
         * Функция  getUserRating  асинхронная и использует библиотеку axios для отправки GET-запроса на сервер. Если
         * пользователь авторизован ( isUserLoggedIn  равно true), функция отправляет запрос на
         * /extensions.php?type=karma . После получения ответа, функция проверяет значение  response.data.response .
         * Если оно равно '1', то значение  rating  обновляется с помощью значения  response.data.karma . Затем
         * ratingToView  также обновляется. После этого функция вызывает себя с помощью  setTimeout  через 30 секунд.
         * Если  response.data.response  не равно '1', функция вызывает себя с помощью  setTimeout  через 5 секунд.
         */
        // async getUserRating() {
        //     if (this.isUserLoggedIn) {
        //         axios({method: 'get', url:'/api/karma.php'})
        //             .then(function( response ){

        //                 if (response.data.response === '1') {

        //                     this.rating = Number(response.data.karma)
        //                     this.ratingToView = this.rating 
        //                 } 
                         
        //                 setTimeout(this.getUserRating.bind(this), 30000)

        //             }.bind( this ) ).catch(function (error) {

        //                 setTimeout(this.getUserRating.bind(this), 60000)
        //                 console.log( "Rating error: " + error );

        //             }.bind( this ));
        //     }
        // },

        /**
         * Она принимает параметр  country , который указывает на страну, для которой нужно получить список лучших
         * услуг.
         *
         * Переменная  topServicesByCountryLoaded  устанавливается в значение  false , что означает, что список лучших
         * услуг по стране еще не загружен.
         *
         * Если текущая страна не пустая, то происходит проверка, есть ли уже список лучших услуг для данной страны в
         * переменной  topServicesByCountry . Если есть, то переменная  topServicesByCountryLoaded  устанавливается в
         * значение  true , что означает, что список уже загружен.
         *
         * Если список лучших услуг для данной страны отсутствует, создается объект  FormData  и добавляются в него
         * параметры  method  со значением  'GET_TOP_SERVICES_BY_COUNTRY'  и  country  со значением переданной страны.
         * Затем с помощью библиотеки  axios  отправляется POST-запрос на сервер по указанному URL  /sms_api/orders.php
         *  с переданными данными.
         *
         * В случае успешного ответа от сервера ( res.data.res  равно  true ), список лучших услуг для данной страны
         * сохраняется в переменной  topServicesByCountry  и устанавливается значение  true  для переменной
         * topServicesByCountryLoaded .
         *
         * В конце функция возвращает список лучших услуг для данной страны из переменной  topServicesByCountry .
         */
        async getTopServicesByCountry(country){
            return runOrderDataHelper('getTopServicesByCountry', this, this.topServicesByCountry[country], [country])
        },

        /**
         * Асинхронная функция  `loadPricesByCountry`  используется для загрузки цен по стране.
         *
         * В начале функции устанавливается флаг  `pricesByCountryLoaded`  в значение  `false` , чтобы указать, что
         * данные еще не загружены.
         *
         * Затем создается объект  `FormData`  и добавляются параметры  `method`  и  `country` .
         *
         * Далее выполняется запрос с использованием библиотеки  `axios` . Запрос отправляется методом  `POST`  на URL
         * `/sms_api/orders.php`  с данными  `data` .
         *
         * После получения ответа, проверяется поле  `res.data.res` . Если оно истинно, то создается временная
         * переменная  `temp`  и присваивается значение  `res.data.data` . Затем в  `temp`  добавляется поле  `time` ,
         * содержащее текущую метку времени.
         *
         * Далее в объект  `this.pricesByCountry`  добавляется свойство с ключом  `country`  и значением  `temp` .
         *
         * Наконец, флаг  `pricesByCountryLoaded`  устанавливается в значение  `true` , чтобы указать, что данные
         * успешно загружены.
         *
         * Если происходит ошибка при выполнении запроса, она выводится в консоль.
         *
         * Очень важно отметить, что оценка кода требует знания контекста и всего проекта, поэтому моя оценка может
         * быть неточной.
         */
        async loadPricesByCountry(country, re = false) {
            return runOrderDataHelper('loadPricesByCountry', this, undefined, [country, re])
        },

        /**
         * Функция  getPricesByCountry  асинхронно получает цены по стране. При вызове функции устанавливается флаг
         * pricesByCountryLoaded  в значение  false , что означает, что данные о ценах по стране еще не загружены.
         * Затем проверяется, была ли уже загружена информация о ценах для текущей страны. Если да, то проверяется,
         * прошло ли более 60000 миллисекунд с момента последней загрузки данных. Если да, то вызывается функция
         * loadPricesByCountry  для загрузки новых данных о ценах по стране. В противном случае, устанавливается флаг
         * pricesByCountryLoaded  в значение  true , что означает, что данные уже загружены и можно использовать. Если
         * информация о ценах для текущей страны отсутствует, также вызывается функция  loadPricesByCountry  для
         * загрузки новых данных.
         */
        async getPricesByCountry(country, re = false) {
            return runOrderDataHelper('getPricesByCountry', this, undefined, [country, re])
        },

        /**
         * Асинхронная функция  loadPricesByService  загружает цены по указанному сервису. Передает данные методом POST
         * на сервер  /sms_api/orders.php . Если получен ответ с положительным результатом ( res.data.res ), сохраняет
         * полученные данные в переменную  pricesByService  и устанавливает флаг  pricesByServiceLoaded  в значение
         * true .
         */
        async loadPricesByService(service, re = false) {
            return runOrderDataHelper('loadPricesByService', this, undefined, [service, re])
        },

        /**
         * Асинхронная функция  getPricesByService  проверяет, загружены ли уже цены для указанного сервиса. Если
         * текущая опция  currServOpt  не является "min", то проверяется наличие цен в переменной  pricesByService .
         * Если цены уже загружены и время последнего обновления не превышает 60000 миллисекунд, то устанавливается
         * флаг  pricesByServiceLoaded  в значение  true . Если цены не загружены или время последнего обновления
         * превышает 60000 миллисекунд, вызывается функция  loadPricesByService  для загрузки цен.
         */
        async getPricesByService(service, re = false) {
            return runOrderDataHelper('getPricesByService', this, undefined, [service, re])
        },

        /**
         * Функция  loadAmountByCountry  асинхронно загружает количество по стране. Она создает объект FormData,
         * добавляет в него метод и страну, затем отправляет POST-запрос на сервер с помощью axios. Если ответ сервера
         * включает поле  res  со значением true, то данные сохраняются во временный объект  temp , в который также
         * добавляется текущее время. Затем данные из  temp  сохраняются в объекте  amountByCountry  по ключу  country
         * , и флаг  amountByCountryLoaded  устанавливается в true.
         */
        async loadAmountByCountry(country, re = false) {
            return runOrderDataHelper('loadAmountByCountry', this, undefined, [country, re])
        },

        /**
         * Функция  getAmountByCountry  асинхронна и используется для получения количества по стране. Она сначала
         * устанавливает флаг  amountByCountryLoaded  в false. Затем, если текущая страна не пустая, проверяется
         * наличие данных по указанной стране в объекте  amountByCountry . Если данные есть и время их получения не
         * превышает 1 минуты, то флаг  amountByCountryLoaded  устанавливается в true. Если данных нет или время их
         * получения превышает 1 минуту, вызывается функция  loadAmountByCountry  для загрузки данных.
         */
        async getAmountByCountry(country, re = false) {
            return runOrderDataHelper('getAmountByCountry', this, undefined, [country, re])
        },

        /**
         * Асинхронная функция  loadAmountByService  используется для загрузки количества и бесед по определенному
         * сервису. Она принимает параметр  service , который указывает на конкретный сервис.
         *
         * Внутри функции создается новый экземпляр  FormData  и заполняется данными о методе и сервисе. Затем
         * используется библиотека  axios  для отправки POST-запроса на сервер по указанному URL. Если запрос успешен,
         * то полученные данные сохраняются в переменную  temp  и добавляются в объекты  amountByService  и
         * conversationsByService . Кроме того, устанавливается флаг  amountByServiceLoaded  в значение  true .
         */
        async loadAmountByService(service, re = false) {
            return runOrderDataHelper('loadAmountByService', this, undefined, [service, re])
        },

        /** 817
         * Функция  getAmountByService  также загружает количество и беседы по сервису, но сначала проверяет, есть ли
         * уже сохраненные данные для этого сервиса. Если данные уже есть и время их получения не превышает 1 минуты,
         * то флаг  amountByServiceLoaded  устанавливается в  true , иначе вызывается функция  loadAmountByService  для
         * загрузки свежих данных.
         */
        async getAmountByService(service, re = false) {
            return runOrderDataHelper('getAmountByService', this, undefined, [service, re])
        },

        /**
         * мусор, без которого не работает  (он тут ненадолго)
         */
        getOperators(opt,country){
            return []
        },

        /**
         * Функция "countrySelection" выполняет выбор страны и обновление текущей страны и выбранного оператора. Если
         * выбранная страна отличается от текущей, то обновляются значения текущей страны и выбранного оператора.
         * Выбранный оператор устанавливается в виде строки, состоящей из префикса "Total_" и имени страны. Если
         * выбранная страна совпадает с текущей, то значение текущей страны сбрасывается.
         */
        countrySelection(country){
            return runOrderCatalogHelper('countrySelection', this, undefined, [country])
        },

        /**
         * Функция filterCountryF() используется для фильтрации стран на основе заданных критериев.
         *
         * В начале функции создается пустой массив country, который будет содержать результаты фильтрации. Затем
         * происходит проверка значения переменной showFavorites. Если она равна false, то в массив country добавляются
         * все страны из массива allCountries. Если showFavorites равна true, то в массив country добавляются только те
         * страны, для которых функция checkFavoritesCountry() возвращает true.
         *
         * Далее происходит проверка значения переменной filterTextCountry. Если она пустая, то массив country
         * присваивается переменной filterCountry без изменений. Если filterTextCountry не пустая, то создается объект
         * option, который содержит опции для поиска с использованием библиотеки Fuse.js. Затем создается экземпляр
         * Fuse с массивом country и опциями option. Выполняется поиск по filterTextCountry с помощью метода search() и
         * результат сохраняется в переменную result.
         *
         * Затем происходит цикл, в котором проверяется, содержится ли shortname каждой найденной страны в массиве
         * filterCountryShortName. Если содержится, то страна добавляется в массив items.
         *
         * В конце функции, массив items присваивается переменной filterCountry, и переменная checkCountryF
         * устанавливается в true.
         *
         * Пожалуйста, дайте знать, если у вас есть какие-либо вопросы.
         */
        async filterCountryF() {
            return runOrderCatalogHelper('filterCountryF', this, false)
        },

        /**
         * Функция  countryPushP()  добавляет все сокращенные названия стран в массив  filterCountryShortName . Она
         * проходит по всем странам в массиве  allCountries  и добавляет их сокращенные названия в верхнем регистре в
         * filterCountryShortName .
         */
        countryPushP(){
            return runOrderCatalogHelper('countryPushP', this, undefined)
        },

        /**
         * Функция  checkEventServ(event)  проверяет выбранное значение  event.target.value  и присваивает его
         * переменной  currServOpt . Если выбранное значение уже равно  currServOpt , то значение  currServOpt  будет
         * изменено на "min", иначе останется выбранное значение.
         */

        checkEventServ(event){
            this.currServOpt = this.currServOpt == event.target.value ? 'min' : event.target.value
        },

        /**
         * Функция  getCountryName(shortname)  находит страну в массиве  allCountries  по сокращенному названию
         * shortname  и возвращает либо полное название страны, либо само сокращенное название, если страна не найдена.
         */
        getCountryName(shortname) {
            return runOrderCatalogHelper('getCountryName', this, shortname, [shortname])
        },

        /**
         * Функция  getService(opt)  находит услугу в массиве  allServices  по опции  opt  и возвращает объект услуги,
         * если она найдена, либо  false , если услуга не найдена.
         */
        getService(opt) {
            return runOrderCatalogHelper('getService', this, false, [opt])
        },

        /**
         * Функция  getServiceByUrl(url)  находит услугу в массиве  allServices  по URL-имени  url  и возвращает объект
         * услуги, если она найдена, либо  false , если услуга не найдена.
         */
        getServiceByUrl(url) {
            return runOrderCatalogHelper('getServiceByUrl', this, false, [url])
        },

        /**
         * Функция  getCountryBySN(shortname)  находит страну в массиве  allCountries  по сокращенному названию
         * shortname  и возвращает объект страны, если она найдена, либо  false , если страна не найдена.
         */
        getCountryBySN(shortname) {
            return runOrderCatalogHelper('getCountryBySN', this, false, [shortname])
        },

        /**
         * Функция  getCountryByUrl(url)  находит страну в массиве  allCountries  по URL-имени  url  и возвращает
         * объект страны, если она найдена, либо  false , если страна не найдена.
         */
        getCountryByUrl(url) {
            return runOrderCatalogHelper('getCountryByUrl', this, false, [url])
        },

        /**
         * Функция  secondsToMinutes(seconds)  преобразует секунды в минуты и возвращает время в формате
         * минуты:секунды . Если количество секунд меньше 10, то добавляется ведущий ноль перед секундами.
         */
        secondsToMinutes(seconds) {
            const minutes = Math.floor(seconds / 60);
            const remainingSeconds = seconds % 60;
            const formattedSeconds = remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;
            return `${minutes}:${formattedSeconds}`;
        },

        /**
         * Этот обработчик  getNumberHandler  используется для получения номера телефона в выбранной стране. Если
         * выбранная страна не пуста и пользователь вошел в систему, то устанавливается текущая страна. Затем
         * проверяется наличие доступных номеров для выбранной услуги в выбранной стране. Если нет доступных номеров,
         * выводится уведомление об этом. Затем создается объект  dataToBuy , содержащий информацию о выбранной стране,
         * операторе и услуге. Этот объект добавляется в массив  orders  с уникальным идентификатором.
         */
        async getNumberHandler(selectedCountry = '') {
            return runOrderAuthHelper('getNumberHandler', this, false, [selectedCountry])
        },

        /**
         * Функция  selectService  используется для выбора опции услуги. Если данные о ценах и количестве доступных
         * номеров не загружены или текущая опция уже выбрана, функция возвращает  false . В противном случае,
         * устанавливается выбранная опция.
         */
        async selectService(opt){
            return runOrderCatalogHelper('selectService', this, false, [opt])
        },

        /**
         * Функция  updateActiveOrders  асинхронно обновляет список активных заказов.
         *
         * В начале функция получает необработанные данные о заказах с помощью метода  getActiveOrders  из API. Если
         * статус полученных данных равен 1, то для каждого заказа добавляется имя соответствующего сервиса, вызывая
         * метод  getService  с параметром  order.opt . Затем полученные заказы добавляются в массив  this.orders .
         *
         * Если статус полученных данных не равен 1, то массив  this.orders  очищается.
         */
        async updateActiveOrders(){
            return runOrderAuthHelper('updateActiveOrders', this, false)
        },

        /**
         * Функция  deleteOrder  асинхронно удаляет указанный заказ из списка  orders . Она использует метод  splice
         * для удаления заказа из массива по его индексу.
         */
        async stopSms( order ){
            return runOrderAuthHelper('stopSms', this, false, [order])
        },


        async deleteOrder(order) {
            return runOrderAuthHelper('deleteOrder', this, false, [order])
        },

        /**
         * Функция  refuseOrder  асинхронно отклоняет указанный заказ, вызывая метод  denialPhone  из объекта  api .
         * Затем она вызывает функцию  deleteOrder , чтобы удалить заказ из списка.
         */
        async refuseOrder(order){
            window.smspvaTrackEvent(
                'activation_cancel_requested',
                window.smspvaActivationParams(order, {
                    cancel_reason: 'user_refused',
                }),
                String(order.id) + ':user_refused'
            )

            this.deleteOrder (order)
            await this.api.denialPhone (order)
        },

        /**
         * Функция  banOrder  асинхронно блокирует указанный заказ, вызывая метод  banPhone  из объекта  api . Затем
         * она вызывает функцию  deleteOrder , чтобы удалить заказ из списка.
         */
        async banOrder(order) {
            window.smspvaTrackEvent(
                'activation_cancel_requested',
                window.smspvaActivationParams(order, {
                    cancel_reason: 'number_banned',
                }),
                String(order.id) + ':number_banned'
            )

            this.deleteOrder (order)
            await this.api.banPhone (order)
        },

        /**
         * Функция  updatePageTitle()  обновляет заголовок страницы в зависимости от выбранных параметров: текущего
         * сервиса ( currServOpt ) и текущей страны ( currentCountry ). Если выбран минимальный сервис ( currServOpt
         * === 'min' ) и страна не выбрана ( currentCountry === '' ), заголовок будет "Активация аккаунтов через SMS
         * для любых сервисов". Если выбран минимальный сервис и выбрана страна, заголовок будет "Получить SMS из
         * [название выбранной страны] - SmsPva.com". Если выбран сервис, отличный от минимального, и страна не
         * выбрана, заголовок будет "Получить SMS онлайн от [название выбранного сервиса] - SmsPva.com". В противном
         * случае заголовок будет "Временный номер для [название выбранного сервиса] в [название выбранной страны]".
         */
        async updatePageTitle() {
            return runOrderRouteHelper('updatePageTitle', this, undefined)
        },

        /**
         * Функция  updateURL()  обновляет URL страницы в зависимости от выбранных параметров. Она получает текущий URL
         * ( currentURL ), добавляет к нему параметры текущего сервиса ( currentServ ) и текущей страны ( currentContr
         * ), и заменяет текущий URL в истории браузера с помощью  window.history.replaceState() .
         */
        async updateURL() {
            return runOrderRouteHelper('updateURL', this, undefined)
        },

        /**
         * Функция  checkURL()  проверяет текущий URL страницы и устанавливает значения параметров  currServOpt  и
         * currentCountry  в соответствии с ним. Если в URL присутствует "service" или "country", функция определяет
         * выбранный сервис или страну и устанавливает соответствующие значения параметров.
         */
        async checkURL() {
            return runOrderRouteHelper('checkURL', this, undefined)
        },

        /**
         * Функция  scrollToTop()  прокручивает страницу вверх до начала содержимого.
         */
        async scrollToTop() {
            return runOrderMiscHelper('scrollToTop', this, undefined)
        },

        /**
         * Функция  scrollToOrders()  прокручивает страницу к разделу с классом "orders" с плавной анимацией.
         */
        async scrollToOrders() {
            return runOrderUiHelper('scrollToOrders', this, undefined)
        },

        /**
         * Функция  log(item)  выводит переданный ей элемент в консоль.
         */
        log(item){
            console.log(item)
        },

        /**
         * Текстовое уведомление пользователя
         *
         * @param {any} mesArray
         * @param {any} type
         * @param {any} debug
         */
        async notifyUser(mesArray, type = 'success', debug = false) {
            return runOrderUiHelper('notifyUser', this, undefined, [mesArray, type, debug])
        },

        /**
         * Функция startTimer() запускает таймер, который каждую секунду генерирует событие "tick" и отправляет его в
         * окно браузера. Это может быть полезно для обновления времени или счетчика на странице. Таймер запускается
         * снова через 1 секунду с помощью setTimeout.
         */
        async startTimer(){
            return runOrderMiscHelper('startTimer', this, undefined)
        },

        /**
         * Функция updateScreenWidth() обновляет значение переменной screenWidth, которая хранит текущую ширину окна
         * браузера. Затем функция проверяет, является ли ширина окна меньше 1200 пикселей и устанавливает переменную
         * mobile в значение true или false соответственно. Это может быть полезно для определения, используется ли
         * мобильное устройство или настольный компьютер, и внесения соответствующих изменений на странице.
         */
        async updateScreenWidth() {
            return runOrderMiscHelper('updateScreenWidth', this, undefined)
        },

        /**
         * Функция  updateCurrentCombo  проверяет время последнего обновления данных о ценах и количестве для текущей
         * страны и выбранной услуги. Если прошло более 5 минут с момента последнего обновления цен для текущей страны
         * или более 1 минуты с момента последнего обновления количества для текущей страны, то происходит обновление
         * данных для этой страны. Аналогично, если выбранная услуга не является минимальной и прошло более 5 минут с
         * момента последнего обновления цен для выбранной услуги или более 1 минуты с момента последнего обновления
         * количества для выбранной услуги, то происходит обновление данных для этой услуги.
         */
        async updateCurrentCombo() {
            return runOrderDataHelper('updateCurrentCombo', this, undefined)
        },

        bindVisibilityChangeHandler() {
            return runOrderInitHelper('bindVisibilityChangeHandler', this, undefined)
        },

        async gotSms(order) {
            return runOrderPricingHelper('gotSms', this, undefined, [order])
        },

        // async watchServiceFromOther() {

        //     let data = new FormData()
        //     data.append('method', 'WATCH_SERVICE_FROM_OTHER')
        //     axios({
        //         method: 'post',
        //         url: '/sms_api/orders.php',
        //         data: data
        //     }).then(function (res) {

        //         this.changeServiceFromOther()

        //     }.bind(this)).catch(function (err) {
        //         console.log(err)
        //     });
        // }

        checkSearchedText(text) {
            return runOrderMiscHelper('checkSearchedText', this, false, [text])
        }

    },




    computed: {
        // EASY BUY: проверяем email только после trim, чтобы пробелы не считались валидным вводом.
        easyBuyEmailValue() {
            return this.easyBuyEmail.trim()
        },
        easyBuySelectedService() {
            return this.getService(this.currServOpt) || {
                service_name: this.currServOpt || 'Selected service',
                image_service_path: '',
            }
        },
        easyBuySelectedCountryName() {
            return this.getCountryName(this.currentCountry) || this.currentCountry || 'Selected country'
        },
        easyBuyEmailIsValid() {
            return this.easyBuyEmailValue !== '' && this.validateEmail(this.easyBuyEmailValue)
        },
        easyBuyEmailError() {
            if (!this.easyBuyEmailTouched) return ''
            if (this.easyBuyEmailValue === '') return 'Enter your email'
            if (!this.easyBuyEmailIsValid) return $L('ords.somethingWrong')
            return ''
        },
        easyBuyCanOpenPaymentStep() {
            return this.easyBuyEmailIsValid && this.easyBuyCaptchaReady
        },
        easyBuyEmailCodeIsValid() {
            return /^\d{6}$/.test(this.easyBuyEmailCode.trim())
        },
        easyBuyEmailCodeError() {
            if (!this.easyBuyCodeTouched) return ''
            return this.easyBuyEmailCodeIsValid ? '' : (window.easyBuyTranslations?.emailCodeInvalid || 'Enter the 6-digit code from your email.')
        },
        easyBuyRegistersUser() {
            return this.easyBuyEmailHandlingMode === 1
        },
        easyBuyUsesFastBuy() {
            return this.easyFastBuyEnabled && !this.easyBuyRegistersUser
        },
        easyBuyVisible() {
            return this.easyBuyEnabled && this.easyBuyRequested && !this.isUserLoggedIn && this.currServOpt !== 'min' && this.currentCountry !== ''
        },
        easyBuyRegisteredFlow() {
            return this.easyBuyRegistered
                && Number(this.balance) <= 0
                && this.isUserLoggedIn
                && this.currServOpt !== 'min'
                && this.currentCountry !== ''
        },
        // EASY BUY: базовая сумма заказа из текущей выбранной пары сервис+страна.
        easyBuyAmountValue() {
            const amount = Number(this.getCheapestOperator(this.currServOpt, this.currentCountry))

            return Number.isFinite(amount) && amount > 0 ? amount : 0
        },
        easyBuySelectedTopupMethodData() {
            return this.easyBuyTopupMethods.find((method) => String(method.id) === String(this.easyBuySelectedTopupMethod)) || null
        },
        easyBuyTopupMethodMinimum() {
            return Math.max(0, Number(this.easyBuySelectedTopupMethodData?.min_amount || 0))
        },
        easyBuyTopupMinimumAmount() {
            return Math.max(this.easyBuyAmountValue, this.easyBuyTopupMethodMinimum)
        },
        easyBuyTopupAmountValue() {
            return Number(this.easyBuyTopupAmount)
        },
        easyBuyTopupAmountError() {
            // The minimum is already explained below the input. Do not show a generic error here.
            return ''
        },
        easyBuyTopupAmountIsAllowed() {
            const amount = this.easyBuyTopupAmountValue
            return Number.isFinite(amount)
                && amount > 0
                && amount >= this.easyBuyTopupMinimumAmount
                && amount <= 1000
        },
        easyBuyCanCreateTopupInvoice() {
            return !!this.easyBuySelectedTopupMethodData
                && !this.easyBuyTopupLoading
                && !this.easyBuyTopupInvoiceLoading
                && !this.easyBuyTopupRedirecting
                && this.easyBuyTopupAmountIsAllowed
        },
        // EASY BUY: минимально допустимая сумма на шаге оплаты зависит от суммы заказа, общего порога и минимума выбранной платёжки.
        easyBuyMinimumChargeAmount() {
            const methodMin = this.easyBuySelectedPaymentMethodMinAmount
            const orderMin = Math.ceil(this.easyBuyAmountValue)

            return Math.max(5, orderMin, methodMin)
        },
        // EASY BUY: отдельная сумма пополнения на шаге оплаты, а не сумма заказа.
        easyBuyChargeAmountValue() {
            const amount = Number(this.easyBuyPaymentAmount)

            return Number.isInteger(amount) && amount > 0 ? amount : 0
        },
        easyBuySelectedPaymentMethodMinAmount() {
            return Number(this.easyBuySelectedPaymentMethodData?.min_amount || 0)
        },
        easyFastBuyChargeAmount() {
            return Math.max(this.easyBuyAmountValue, Number(this.easyBuySelectedPaymentMethodData?.min_amount || 0))
        },
        easyBuyChargeAmount() {
            return Math.max(Number(this.easyBuyOrder?.price || this.easyBuyAmountValue || 0), this.easyBuySelectedPaymentMethodMinAmount)
        },
        easyBuyProgress() {
            return Math.max(25, Math.min(100, this.easyBuyStep * 25))
        },
        easyBuyCanTryAnotherNumber() {
            // Timer text is deliberately read to make this computed value refresh each second.
            void this.easyBuyTimerToView
            return !!this.easyBuyOrder
                && !this.easyBuyOrder.payment_id
                && !this.easyBuyOrder.completed
                && this.easyBuySmsWaitStartedAt > 0
                && Date.now() - this.easyBuySmsWaitStartedAt >= 60000
        },
        easyBuyWaitingText() {
            const messages = [
                $L('ords.gettingSMS'),
                $L('ords.ord_message_serviceIs_delayed'),
                $L('ords.ord_message_checking_service_for_sending'),
                $L('ords.ord_message_blocked_service_by_Ip'),
                $L('ords.ord_message_problem_receiving_sms'),
                $L('ords.ord_message_check_data_correct'),
            ]
            return messages[this.easyBuyWaitingStep % messages.length]
        },
        // EASY BUY: держим отдельную ошибку суммы, чтобы поле и кнопка реагировали синхронно.
        easyBuyPaymentAmountError() {
            if (!this.easyBuyShowPaymentAmountInput) {
                return ''
            }

            const rawValue = String(this.easyBuyPaymentAmount).trim()

            if (rawValue === '') {
                return `Enter an amount from ${this.easyBuyMinimumChargeAmount} to 1000 USD.`
            }

            if (!/^\d+$/.test(rawValue)) {
                return 'Amount must be a whole number in USD.'
            }

            const amount = Number(rawValue)

            if (!Number.isInteger(amount)) {
                return 'Amount must be a whole number in USD.'
            }

            if (amount < this.easyBuyMinimumChargeAmount) {
                return `Amount must be at least ${this.easyBuyMinimumChargeAmount} USD.`
            }

            if (amount > 1000) {
                return 'Amount must not exceed 1000 USD.'
            }

            return ''
        },
        easyBuyCanSubmitPayment() {
            return !this.easyBuyLoading
                && !this.easyBuyInvoiceLoading
                && !!this.easyBuySelectedPaymentMethod
                && !!this.easyBuyOrder
        },
        // EASY BUY: поле суммы показываем, если заказ дешевле 5 USD или выбранная платёжка требует больший минимум.
        easyBuyShowPaymentAmountInput() {
            return this.easyBuyAmountValue < 5 || this.easyBuySelectedPaymentMethodMinAmount > this.easyBuyAmountValue
        },
        // EASY BUY: фильтруем локальный список платёжек по поисковой строке третьего шага.
        easyBuyFilteredPaymentMethods() {
            const search = this.easyBuyPaymentSearch.trim().toLowerCase()

            if (!search) {
                return this.easyBuyPaymentMethods
            }

            return this.easyBuyPaymentMethods.filter((method) => {
                const title = method.title ? method.title.toLowerCase() : ''
                const description = method.description ? method.description.toLowerCase() : ''

                return title.includes(search) || description.includes(search)
            })
        },
        // EASY BUY: держим выбранную платёжку отдельным computed, чтобы summary-card показывал её без ручного поиска в tpl.
        easyBuySelectedPaymentMethodData() {
            return this.easyBuyPaymentMethods.find((method) => String(method.id) === String(this.easyBuySelectedPaymentMethod)) || null
        },

        /**
         * Свойство  sortedList  используется для сортировки списка  filterCountry  в зависимости от значения
         * переменной  sorting . Если  sorting  равно 0, то возвращается исходный список без сортировки. Если  sorting
         * равно 1 или 2, то происходит сортировка по ценам. В зависимости от значения  currServOpt  выбираются либо
         * minPrices , либо  pricesByService[currServOpt]  в качестве источника цен. Если  currServOpt  равно 'min', то
         * используются минимальные цены. В случае  sorting  равного 1, список сортируется по возрастанию цен, а в
         * случае  sorting  равного 2 - по убыванию цен. Если  sorting  равно 3 или 4, то происходит сортировка по
         * общей сумме или количеству разговоров. Если  currServOpt  равно 'min' или  amountByServiceLoaded  равно
         * false, то возвращается исходный список без сортировки. В противном случае, в зависимости от значения
         * currServOpt  выбирается  amountByService  или  conversationsByService[currServOpt]  в качестве источника
         * данных. Список сортируется по возрастанию или убыванию общей суммы или количества разговоров.
         */
        sortedList() {
            return runOrderCatalogHelper('sortedList', this, this.filterCountry)
        },

        /**
         * Свойство  sortedServices  используется для сортировки списка  allServices  в зависимости от значения
         * переменной  serviceSearch . Если  serviceSearch  пустая строка, то возвращается исходный список без
         * сортировки. В противном случае, создается объект  Fuse  с настройками  fuseOptions  и производится поиск по
         * списку  allServices  с использованием  serviceSearch . Результат поиска добавляется в новый список  items .
         * Также в список добавляется дополнительный элемент "OTHER (no guarantee)". Если результат поиска пустой, то
         * возвращается только этот элемент. В противном случае, возвращается список  items .
         */


        sortedServices() {
            return runOrderCatalogHelper('sortedServices', this, this.allServices)
        },
    },

    /**
     * В данной функции происходит инициализация некоторых переменных и выполнение нескольких операций.
     *
     * Вначале устанавливается значение переменной currServOpt равным 'min'. Затем вызывается метод countryPushP(),
     * который выполняет определенные действия связанные с выбором страны. Далее выполняется метод checkURL() с
     * использованием ключевого слова await, что означает, что выполнение кода будет приостановлено до тех пор, пока не
     * будет выполнена данная функция. Затем вызывается метод filterCountryF(), который фильтрует страны. Если значение
     * переменной currServOpt равно 'min' и значение переменной currentCountry пусто, то переменная mainLoaded
     * устанавливается в значение true.
     *
     * Далее устанавливается значение переменной title в объекте popup равным значению popupTitle с ключом
     * popupVariants.notLike. Также устанавливается значение переменной variantPopup в объекте popup равным значению
     * popupVariants.notLike.
     *
     * Далее из локального хранилища извлекаются значения favorites_country, simsms_favs и showCountryFavorites и
     * присваиваются соответствующим переменным favoritesCountry, favoritesService и showFavorites.
     *
     * Наконец, в объект topServicesFiltered копируются значения из объекта topServicesOpts с помощью метода
     * Object.assign().
     */
    async created(){
        return runOrderInitHelper('created', this, undefined)
    },

    /**
     * В данном коде происходит инициализация компонента. В методе  mounted()  происходят следующие действия:
     *
     * 1. Значение свойства  service_name  объекта в массиве  allServices , у которого свойство  service_opt  равно
     * 'opt4', заменяется на 'VK.com, OK.ru, Mail.ru, Youla, ICQ, Delivery Club'.
     * 2. Массив  allServices  сортируется по значению свойства  service_name  в алфавитном порядке.
     * 3. Получается ширина элемента с id 'orders_select' и сохраняется в переменную  width .
     * 4. Получается элемент 'html' и сохраняется в переменную  html .
     * 5. Если ширина  width  больше или равна 380, то устанавливается размер шрифта элемента 'html' равным 7 пикселям.
     * 6. Выполняется асинхронная функция  startTimer() .
     * 7. Добавляется слушатель события  resize  на объект  window , который вызывает метод  updateScreenWidth .
     * 8. Выполняется асинхронная функция  updateScreenWidth() .
     * 9. Значение свойства  muted  устанавливается из значения, хранящегося в  localStorage  под ключом 'isMuted'.
     * 10. Выполняется асинхронная функция  getUserRating() .
     * 11. Если пользователь авторизован, то выполняется асинхронная функция  updateActiveOrders() .
     */
    async mounted(){
        const result = await runOrderInitHelper('mounted', this, undefined)
        await this.loadFastBuyOrder()
        if (this.easyBuyRegisteredFlow) {
            await this.loadEasyBuyTopupMethods()
            this.startEasyBuyBalancePolling()
        }
        if (ORDER_PAGE_EASYBUY_START_ORDER && this.isUserLoggedIn && this.currServOpt !== 'min' && this.currentCountry) {
            const url = new URL(window.location.href)
            url.searchParams.delete('easy_buy_start_order')
            window.history.replaceState(window.history.state, '', url.toString())
            await this.$nextTick()
            this.getNumberHandler(this.currentCountry)
        }

        return result
    },

    /**
     * В методе  beforeDestroy()  удаляется слушатель события  resize  с объекта  window .
     */
    beforeDestroy() {
        this.stopEasyBuyBalancePolling()
        return runOrderInitHelper('beforeDestroy', this, undefined)
    },

    beforeUnmount() {
        this.stopEasyBuyBalancePolling()
    }

})


// Если вы часто создаете аккаунты на этом сервисе, может произойти блокировка вашего IP. Используйте прокси, чтобы избежать этой проблемы.
// Если вы не получаете сообщение, попробуйте зарегистрироваться в режиме инкогнито. Если и это не помогает, попробуйте использовать прокси.
// Не получили сообщение? Проверьте правильность выбора сервиса и страны, а также введенные данные.

                    // serviceIsDelayed: "Different services send messages at different speeds, sometimes you need to wait a little longer",

                    // checkingTheServiceForSending: "Check whether the service sent the message accurately; sometimes after filling it out they ask for additional activity",
                    // blockedServiceById: "If you often create accounts on this service, your IP may be blocked. Use a proxy to avoid this problem.",
                    // problemReceivingSms: "If you don't receive the message, try registering in incognito mode. If this doesn't help, try using a proxy.",
                    // checkDataCorrect: "Didn't receive the message? Check that you have selected the correct service and country, as well as the entered data."


if (typeof window.registerOrderDetailComponent !== 'function') {
    throw new Error('order-detail.js is required before order.js')
}
window.registerOrderDetailComponent(app)
app.mount('#main')
